<section class="aarni-font relative w-full object-cover mt-[80px]">
    <picture>
        <source media="(min-width: 1024px)" [srcset]="getBackgroundImage()">
        <source media="(min-width: 768px)" [srcset]="getBackgroundImageForMediumScreen()">
        <img [src]="getBackgroundImageForPhoneView()" alt="" class="h-auto w-full">
    </picture>

    <div class="hidden xl:flex absolute bottom-4 xl:bottom-4 left-0 w-full justify-center z-10 gap-6 xl:gap-16 px-4"
         *ngIf="pageTitle === 'NCC'">
        <button
            *ngFor="let tab of nccTabs"
            (click)="selectTab(tab.key)"
            [ngClass]="{
        'bg-white text-[#003b29] border border-[#003b29]': selectedTab === tab.key,
        'bg-[#003b29] text-white': selectedTab !== tab.key
      }"
            class="px-8 xl:px-12 py-2 rounded-full font-semibold hover:bg-white hover:text-[#003b29] hover:border-[#003b29] transition-all duration-300"
        >
            {{ tab.label }}
        </button>
    </div>
</section>
<section class="aarni-font py-4 bg-emerald-100 xl:hidden px-2 lg:px-4" *ngIf="pageTitle === 'NCC'">
    <div class="grid grid-cols-2 md:grid-cols-6 gap-4 md:gap-1">
        <button
            *ngFor="let tab of nccTabs"
            (click)="selectTab(tab.key)"
            [class]="
          'w-full px-1 lg:px-4 py-2 rounded-full font-semibold border transition-all duration-300 ' +
          (selectedTab === tab.key
            ? 'bg-white text-[#003b29] border-[#003b29]'
            : 'bg-[#003b29] text-white border-transparent hover:bg-white hover:text-[#003b29] hover:border-[#003b29]')
        "
        >
            {{ tab.label }}
        </button>
    </div>
</section>

<section class="aarni-font">
    <div class=" w-full flex flex-col lg:flex-row  py-12 "
         [ngClass]="{
    'mx-auto gap-8 px-4 container': pageTitle !== 'NCC'
  }">
        <aside class="w-full lg:w-1/4 space-y-4 lg:max-h-screen lg:overflow-y-auto overflow-x-hidden pr-2"
               *ngIf="pageTitle !== 'NCC'">
            <div class="border-t-8 border-blue-400">
                <div class="bg-white shadow border border-gray-300">
                    <h2 class="text-lg font-bold p-4">Campus Life</h2>
                    <div class="">
                        <a [href]="'/campus-life/infrastructure'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Infrastructure', 'text-blue-600 bg-white' : pageTitle !== 'Infrastructure'}"
                           class="flex items-center space-x-2 p-3 w-full border-y border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Infrastructure</span>
                        </a>
                        <a [href]="'/campus-life/academic-facilities'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Academic Facilities', 'text-blue-600 bg-white' : pageTitle !== 'Academic Facilities'}"
                           class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Academic Facilities</span>
                        </a>
                        <a [href]="'/campus-life/campus-facilities'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Campus Facilities', 'text-blue-600 bg-white' : pageTitle !== 'Campus Facilities'}"
                           class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Campus Facilities</span>
                        </a>
                        <a [href]="'/campus-life/transportation'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Transportation', 'text-blue-600 bg-white' : pageTitle !== 'Transportation'}"
                           class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Transportation</span>
                        </a>
                        <a [href]="'/campus-life/residential-facilities'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Residential Facilities', 'text-blue-600 bg-white' : pageTitle !== 'Residential Facilities'}"
                           class="flex items-center space-x-2 p-3 w-full  border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Residential Facilities</span>
                        </a>
                        <a [href]="'/campus-life/library'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Library', 'text-blue-600 bg-white' : pageTitle !== 'Library'}"
                           class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Library</span>
                        </a>
                        <a [href]="'/campus-life/schools'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Schools', 'text-blue-600 bg-white' : pageTitle !== 'Schools'}"
                           class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Schools</span>
                        </a>
                        <!--   <a [href]="'/campus-life/auditorium'"
                                [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Auditorium', 'text-blue-600 bg-white' : pageTitle !== 'Auditorium'}"
                                class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                           >
                               <i class="fa fa-arrow-right"></i>
                               <span>Auditorium</span>
                           </a>-->
                        <a [href]="'/campus-life/it-services'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'IT Services', 'text-blue-600 bg-white' : pageTitle !== 'IT Services'}"
                           class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>IT Services</span>
                        </a>
                        <a [href]="'/campus-life/green-campus'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Green Campus', 'text-blue-600 bg-white' : pageTitle !== 'Green Campus'}"
                           class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Green Campus</span>
                        </a>
                        <a [href]="'/campus-life/ncc'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'NCC', 'text-blue-600 bg-white' : pageTitle !== 'NCC'}"
                           class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>NCC</span>
                        </a>
                        <a [href]="'/campus-life/extra-curricular-activities'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Extra Curricular Activities', 'text-blue-600 bg-white' : pageTitle !== 'Extra Curricular Activities'}"
                           class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Extra Curricular Activities</span>
                        </a>
                    </div>
                </div>
            </div>
            <h2 class="text-lg font-semibold mb-4 hidden lg:block">Quick Links</h2>
            <div class="bg-white p-4 rounded-lg shadow hidden lg:block border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/quick-links/student-testimonial" class="flex items-center space-x-3 p-2 rounded-lg">
                        <div>
                        <span class="w-16 h-16 flex items-center justify-center bg-green-600 text-white rounded-full">
                            <i class="fa fa-comment text-2xl"></i>
                        </span>
                        </div>
                        <span class="text-gray-700 font-medium text-[16px] xl:text-xl">Testimonials</span>
                    </a>
                </div>
            </div>

            <div class="bg-white p-4 rounded-lg shadow hidden lg:block border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/whats-happening/event-calendar" class="flex items-center space-x-3 p-2 rounded-lg">
                        <div>
                        <span class="w-16 h-16 flex items-center justify-center bg-yellow-500 text-white rounded-full">
                          <i class="fa fa-calendar text-2xl"></i>
                        </span>
                        </div>
                        <span class="text-gray-700 font-medium text-[16px] xl:text-xl">What's Happening</span>
                    </a>
                </div>
            </div>
            <div class="bg-white p-4 rounded-lg shadow hidden lg:block border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/quick-links/contact-us" class="flex items-center space-x-3 p-2 rounded-lg ">
                        <div>
                        <span class="w-16 h-16 flex items-center justify-center bg-pink-600 text-white rounded-full">
                <i class="fa fa-phone text-2xl"></i>
            </span></div>
                        <span class="text-gray-700 font-medium text-[16px] xl:text-xl">Contact Us</span>
                    </a>
                </div>
            </div>

            <!--   <div class="bg-white p-4 rounded-lg shadow hidden lg:block border-gray-200 border-2">
                   <div class="space-y-2">
                       <a href="/quick-links/image-gallery" class="flex items-center space-x-3 p-2 rounded-lg ">
                           <div>
               <span class="w-16 h-16 flex items-center justify-center bg-blue-600 text-white rounded-full">
                   <i class="fa fa-camera text-2xl"></i>
               </span>
                           </div>
                           <span class="text-gray-700 font-medium text-[16px] xl:text-xl">Image Gallery</span>
                       </a>
                   </div>
               </div>-->
        </aside>
        <div class="flex-1 aarni-font">
            <div
                class=" bg-white h-fit"
                [ngClass]="{
    'border shadow-lg border-gray-200 p-12': pageTitle !== 'NCC'
  }">
                <h3 class="font-semibold text-[22px]" *ngIf="pageTitle !== 'NCC'">
                    {{ pageTitle }}
                </h3>
                <div class="text-justify" *ngIf="pageTitle === 'Infrastructure'">
                    <p class="mt-8 text-gray-800">
                        Spread over 120 acres, ARNI University’s campus is the perfect combination of modern
                        infrastructure and eye-catching beautiful natural scenery. Moreover, the lush-green breathtaking
                        Dhauladhar Mountain Ranges works as the ornaments of the place. The overall natural scene
                        creates inspiring surroundings that foster creativity, innovation, and peace to harness growth
                        and productivity. The Campus is equipped with all amenities to offer an exceptional learning
                        experience.
                    </p>
                    <p class="mt-8 text-gray-800">The University has an extremely well-designed infrastructure of
                        approx.
                        eight Academic Blocks and
                        very well equipped with state-of-the-art Laboratories, to inspire students to learn their
                        lessons in a very congenial environment. The classrooms have all modern learning aids/ comforts
                        to activate all senses of the students and make them learning savvy. The classrooms and Seminar
                        Halls are also equipped with the latest teaching aids and presentation tools.
                    </p>
                    <p class="mt-8 text-gray-800">Whether you’re studying, researching, or simply unwinding, ARNI
                        University offers a <span class="font-semibold">“home away
                        from home”</span> that ensures comfort, convenience, and growth.</p>
                    <h5 class="font-semibold text-[18px] mt-10 text-gray-700">
                        Our Academic Blocks
                    </h5>
                    <p class="mt-8 text-gray-800">Following the motivation of educational excellence, our academic
                        blocks
                        are designed with a focus
                        on functionality. It is not just a building; it is a center of activity, collaborative learning,
                        intellectual curiosity, and academic growth. ARNI University is committed to providing the best
                        learning experience with world-class infrastructure. Thus, we have designed all 8 blocks with
                        all the necessary amenities that match the international standard. </p>
                    <p class="mt-8 text-gray-800">All the classrooms are equipped with advanced teaching tools with
                        wi-fi
                        facility. Additionally,
                        the entire premises are under CCTV surveillance to provide utmost security to the students and
                        faculty along with eco-friendly smoke-free zone. </p>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 justify-items-center gap-4 mt-6">
                        <div *ngFor="let image of academicBlockImages" class="border shadow w-full">
                            <img [src]="image.image_url" [alt]="image.name"
                                 class="w-full object-cover border h-[150px]">
                            <div class="font-semibold flex items-center justify-center py-4">
                                {{ image.name | titlecase }}
                            </div>
                        </div>
                    </div>

                    <h5 class="font-semibold text-xl mt-16 text-gray-700">
                        Library Facilities – A Peaceful Place to Acquire Knowledge
                    </h5>

                    <p class="mt-4 text-gray-800">
                        The library is the hub for acquiring knowledge for mind development. ARNI library offers an
                        extensive collection of books in over 20,000 different streams. The library is well-furnished
                        with air conditioning that provides a comfortable, peaceful environment for the students.
                        Moreover, the library is filled with a large number of journals, motivational books, and
                        research papers related to management, technology, science, and the arts.
                    </p>

                    <ul class="list-disc pl-6 my-2 text-gray-800">
                        <li>Seamless access to books, e-books, and research papers to keep updated with global academic
                            trends.
                        </li>
                        <li>A dedicated study zone, along with comfortable chairs and desks appropriate for group
                            studies or individual studies.
                        </li>
                        <li>Well-organized bookshelf along with professional guidance to help for the most appropriate
                            book.
                        </li>
                    </ul>

                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
                        <div *ngFor="let image of libraryImages">
                            <img [src]="image.image_url" [alt]="image.name"
                                 class="w-full object-cover border h-[150px]">
                        </div>
                    </div>

                    <h5 class="font-semibold text-xl mt-16 text-gray-700">
                        Mess Facilities – Good Food, Good Mind
                    </h5>
                    <p class="mt-4 text-gray-800">
                        At ARNI University, we value the importance of wholesome meals in fostering a productive
                        academic journey. Our Mess facility is designed to provide well-nourished and nutritious food
                        made with proper hygiene. The mess is not just to have food only; it is the place where students
                        strengthen their bond over meals. The Mess charges are paid in advance for the whole Semester,
                        at the beginning of each Semester, along with other charges of the University.
                    </p>
                    <ul class="pl-6 list-disc my-2 text-gray-800">
                        <li>Well-curated menu offering seasoned vegetables, pulses, and fruits for the proper diet of
                            the students.
                        </li>
                        <li>To maintain proper hygiene and taste, a dedicated team is assigned to look over the
                            end-to-end process.
                        </li>
                        <li>The university has two separate large dining halls for the boys’ hostellers and girls’
                            hostellers, ensuring proper management and security.
                        </li>
                    </ul>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
                        <div *ngFor="let image of messImages">
                            <img [src]="image.image_url" [alt]="image.name"
                                 class="w-full object-cover border h-[150px]">
                        </div>
                    </div>


                    <h5 class="font-semibold text-xl mt-16 text-gray-700">
                        Sports Facilities
                    </h5>
                    <p class="mt-4 text-gray-800">
                        Being one of the foremost educational institutes, we encourage extracurricular activities for
                        the overall growth of our students, whether it's about academic or physical development. Thus,
                        the campus provides sports facilities to all the students and has almost all the necessary
                        assets for indoor or outdoor activities. The campus has a modern gym along with professional
                        trainers. We believe in the vision of “Khelega India, Tabhi Toh Badhega India." We have a team
                        of professional trainers and instructors for various sports that guide our upcoming athletes
                        most appropriately.
                    </p>
                    <p class="mt-4 text-gray-800">Our students participated in numerous State and intercollegiate
                        competitions. Their courage and our support have brought trophies to the University several
                        times, and this will continue for many upcoming years.
                    </p>
                    <ul class="list-disc ml-6 mt-8">
                        <li>
                            Cricket
                        </li>
                        <li>
                            Football
                        </li>
                        <li>
                            Basketball
                        </li>
                        <li>
                            Hockey
                        </li>
                        <li>
                            Volleyball
                        </li>
                        <li>
                            Lawn Tennis
                        </li>
                        <li>
                            Table Tennis
                        </li>
                        <li>
                            Badminton
                        </li>
                        <li>
                            Kho Kho
                        </li>

                    </ul>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
                        <div *ngFor="let image of sportsFacilitiesImages">
                            <img [src]="image.image_url" [alt]="image.name"
                                 class="w-full object-cover border h-[150px]">
                        </div>
                    </div>

                    <h5 class="font-semibold text-xl mt-16 text-gray-700">
                        Hostel Facilities
                    </h5>
                    <p class="mt-4 text-gray-800">
                        ARNI University takes pride in providing comfortable, secure, well-equipped, and well-maintained
                        hostel facilities to our students that ensure they feel like a home while manifesting their
                        dreams. The rooms and ambiance of our hotel are designed to encourage learning, growth, and
                        relaxation.
                    </p>
                    <ul class="list-disc my-2 pl-6 text-gray-800">
                        <li>To ensure privacy, a friendly atmosphere, and security, we have a separate hostel building
                            for boys and girls.
                        </li>
                        <li>Our hostel is spacious and well-furnished and offers rooms for single, double, or even
                            triple occupancy that suit every student's preference.
                        </li>
                        <li>For the comfort of the students, our hostel offers hygienic, delicious food, clean drinking
                            water, electricity backup, and 24/7 CCTV surveillance. We care extra for safety and
                            security, especially for the girls, to serve them the best they deserve.
                        </li>
                    </ul>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
                        <div *ngFor="let image of hostelImages">
                            <img [src]="image.image_url" [alt]="image.name"
                                 class="w-full object-cover border h-[150px]">
                        </div>
                    </div>

                    <h5 class="font-semibold text-xl mt-16 text-gray-700">
                        GYM Facilities – Empowering Wellness and Fitness
                    </h5>
                    <p class="mt-4 text-gray-800">
                        Following the concept of this ever-evolving modern ear, we understand the importance of physical
                        wellness. With cutting-edge gym facilities, we provide students with a perfect environment to
                        stay fit, energetic, and stress-free. Our goal is to lead a healthy life.
                    </p>
                    <ul class="pl-6 list-disc my-2text-gray-800 text-gray-800">
                        <li>We have a gender-specific workout area for boys and girls to ensure safe, secure, private,
                            and comfortable surroundings.
                        </li>
                        <li>Our gym is equipped with the latest advanced fitness machines, free weights, cardio
                            sections, etc.
                        </li>
                        <li>All the students are on a fitness journey under the supervision of nationally-famed
                            instructors to avoid any mishaps.
                        </li>
                    </ul>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
                        <div *ngFor="let image of gymImages">
                            <img [src]="image.image_url" [alt]="image.name"
                                 class="w-full object-cover border h-[150px]">
                        </div>
                    </div>

                    <h5 class="font-semibold text-xl mt-16 text-gray-700">
                        Transport Facilities – Safe, Reliable, and Convenient
                    </h5>
                    <p class="mt-4 text-gray-800">
                        We prioritize the safety, comfort, and convenience of the students and faculty to commute daily
                        with our well-organized transport facilities. Whether you are attending your daily classes,
                        participating in extracurricular activities, or returning home, ARNI transportation ensures a
                        smooth journey along with your safety and security. The students who opt for transportation need
                        to pay the full amount at the beginning of the whole semester.
                    </p>
                    <ul class="list-disc pl-6 my-2 text-gray-800">
                        <li>Pick and drop Facilities in our comfortable vehicle for students from the surrounding areas
                            of Himachal Pradesh, Punjab, and Jammu & Kashmir.
                        </li>
                        <li>The vehicles are equipped with the necessary safety measures such as GPS tracking and
                            First-aid kits.
                        </li>
                        <li>Well-planned pickup facility allows students to concentrate on their studies rather than on
                            commuting.
                        </li>
                    </ul>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
                        <div *ngFor="let image of transportationImages">
                            <img [src]="image.image_url" [alt]="image.name"
                                 class="w-full object-cover border h-[150px]">
                        </div>
                    </div>

                    <h5 class="font-semibold text-xl mt-16 text-gray-700">
                        Medical Facilities – Your Well-Being, Our Responsibility
                    </h5>
                    <p class="mt-4 text-gray-800">
                        Good health is essential for a thriving, fruitful academic journey. ARNI has established a
                        dedicated medical facility on the campus area for the well-being of students and faculty
                        members. For immediate medical help, the ARNI’s “Central Medical Clinic” is open 24/7. It has a
                        dedicated medical room along with trained staff and doctors.
                    </p>
                    <ul class="pl-6 list-disc my-2 text-gray-800">
                        <li>ARNI has a 10-bed “Central Medical Clinic” along with well-trained staff, doctors, and an
                            ambulance.
                        </li>
                        <li>The medical facility is filled with essential medical equipment, drugs, and important
                            medicines to avoid delays in any emergency.
                        </li>
                        <li>Also, regular check-ups, health drives, and wellness program campaigns take place on a
                            regular basis to promote good health.
                        </li>
                    </ul>
                    <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 mt-6">
                        <div *ngFor="let image of medicalFacilitiesImages">
                            <img [src]="image.image_url" [alt]="image.name"
                                 class="w-full object-cover border h-[250px]">
                        </div>
                    </div>
                </div>
                <div class="text-justify" *ngIf="pageTitle === 'Academic Facilities'">
                    <p class="mt-8 text-gray-800">
                        A student-centric infrastructure with all the required amenities is the foundation of effective
                        learning that provides a holistic development to the students. Spread over 111 acres, of which
                        27.7 acres functional area, our campus is thoughtfully designed to build an eco-friendly
                        learning system that fosters academic rigor, collaborative learning, and research innovations.
                        With advanced facilities and technologies, we offer an environment where education transcends
                        traditional boundaries and empowers student success.
                    </p>
                    <p class="mt-2 text-gray-800">Whether it is about the hands-on experience in our labs, a wealth of
                        knowledge in the library, or
                        internet connectivity across the campus, our academic facilities have been established with a
                        purpose to nurture talent, spark innovation, and prepare our students for real-world challenges.
                    </p>
                    <p class="mt-4 text-gray-800">
                        <strong>Library & Learning Resource Center</strong>
                        As we know, the library is the hub of knowledge, and ARNI’s library is no exception. Books play
                        a pivotal role in the academic life of a student as well as a faculty member. ARNI’s central
                        library has a rich collection of more than 20,000 books spanning across diverse disciplines such
                        as science, health, technology, management, humanities, and arts. Moreover, over than 24 printed
                        journals and 36 computers in the library ensure easy access to research and academic discourse.
                    </p>
                    <p class="mt-4 text-gray-800">
                        <strong>Modern Laboratories and Research Facilities</strong>
                        Not only in textbook learning, but we also believe that practical knowledge is an integral part
                        of learning. Thus, we have designed our laboratories and research facilities equipped with all
                        the necessary tools. The labs are well-furnished and aligned with the curriculum of various
                        academic programs to provide an exposure to experimental learning, simulations, and research
                        work. Whether in engineering, life sciences, or applied sciences, each lab is outfitted with
                        modern instruments and tools that promote experiential learning. Faculty-led projects, student
                        innovations, and industry-collaborated research are strongly encouraged within our lab
                        ecosystem.
                    <p class="mt-4 text-gray-800">
                        <strong>Smart Classrooms & Seminar Halls</strong>
                        Our classrooms are not just a physical space for learning and teaching, as others; we have over
                        15 smart boards and 16 LCD projectors to provide a well-suited place for learning. To make
                        lectures interactive and visually appealing, our classrooms and seminar halls offer a blended
                        learning experience. The seminar halls are perfectly designed for large gatherings, especially
                        for guest lectures, conferences, presentations, and workshops. Additionally, comfortable seating
                        arrangements and sound quality make these spaces ideal.
                    <p class="mt-4 text-gray-800">
                        <strong>Sports and Recreational Infrastructure</strong>
                        Physical fitness and mental well-being are crucial for students’ overall development in terms of
                        knowledge and skills. To support fitness among the students, we offer a wide range of sports and
                        recreational facilities, including a cricket ground, a football ground, lawn tennis, basketball,
                        volleyball, and a badminton court. Moreover, we have separate gyms for boys and girls equipped
                        with modern workout equipment. Through our sports and recreational facilities, we promote a
                        balanced lifestyle, discipline, and teamwork.
                    </p>
                    <p class="mt-4 text-gray-800">
                        <strong>Hostel and Dining Facilities</strong>
                        ARNI’s hostels are safe, clean, and comfortable, serving as the second home of our students.
                        With 24/7 security, healthy food made with proper hygiene, and digital connectivity, our
                        accommodation is an ideal place for students. With three boys' hostels with the capacity of 514
                        students and 1 girls' hostel with the capacity of 171 students, we offer well-furnished rooms,
                        common rooms, and a study area.
                    </p>
                    <p class="mt-4 text-gray-800">
                        <strong>Healthcare & Medical Services</strong>
                        ARNI University places a high priority on the health and safety of its community. The campus
                        includes a fully functional medical center equipped with two wards, each having five beds, and a
                        dedicated doctor’s room. Emergency medical services, including ambulance availability,
                        stretchers, and wheelchairs, are accessible round the clock. Periodic health checkups, tie-ups
                        with local hospitals, and the presence of trained medical staff ensure that students receive
                        immediate and effective healthcare whenever needed.
                    </p>
                </div>
                <div class="text-justify" *ngIf="pageTitle === 'Campus Facilities'">
                    <p class="mt-8 text-gray-800">At ARNI University, our motto is to provide a holistic educational
                        environment where
                        students not
                        only get academic excellence but also enjoy a secure, active, and vibrant campus life. Our
                        campus infrastructure is equipped with all the required amenities, with modern technology to
                        support aspects of a student’s journey. From learning with digital boards and agriculture to
                        health and recreation, ARNI offers the best place to learn peacefully.</p>
                    <h5 class="font-semibold text-xl mt-10 text-gray-700">
                        Sports Facilities
                    </h5>
                    <p class="mt-8 text-gray-800">
                        To support the physical and mental health of students, ARNI University offers a wide range of
                        indoor and outdoor facilities for students. Moreover, we trained students on professional
                        grounds to serve the nation as athletes. We have the best physical trainers who train our
                        students in various games such as cricket, football, volleyball, and basketball, like outdoor
                        games. Additionally, table tennis, chess, and badminton are some of the other games we have
                        offered to the students. Regular tournaments and inter-college competitions are also organized
                        to foster team spirit and sportsmanship among students.
                    </p>
                    <!--  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
                          <div *ngFor="let image of hostelImages">
                              <img [src]="image.image_url" [alt]="image.name"
                                   class="w-full object-cover border h-[150px]">
                          </div>
                      </div>
                      <h5 class="font-semibold text-[18px] mt-10 text-gray-700">
                          Mess Facilities
                      </h5>
                      <p class="mt-4 text-[14px]">
                          The University has two separate large Dining Halls for the Boy and Girl hostellers, connected
                          with their Hostels to ensure their better time management and security. The menu is decided by
                          the Mess Committee, comprising of students from all hostels and the Wardens. The Mess charges
                          are paid in advance for whole Semester, in the beginning of each Semester along with other
                          charges of the University.
                      </p>
                      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
                          <div *ngFor="let image of messImages">
                              <img [src]="image.image_url" [alt]="image.name"
                                   class="w-full object-cover border h-[150px]">
                          </div>
                      </div>
                      <h5 class="font-semibold text-[18px] mt-10 text-gray-700">
                          Sports Facilities
                      </h5>
                      <p class="mt-8 text-[14px]">
                          There are separate Hostels for Boys and Girls with all the modern and comfort facilities. The
                          rooms are well furnished, spacious and airy to enable the living of students as comfortable as
                          possible. In fact it is with a concept to have “Home away from Home”. We cater for approx 700
                          students on double and triple sharing basis. We pay special attention for the safety and
                          comforts of the students, especially the Girl students so that they all feel secured,
                          comfortable and confident.

                      </p>-->
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
                        <div *ngFor="let image of sportsFacilitiesImages">
                            <img [src]="image.image_url" [alt]="image.name"
                                 class="w-full object-cover border h-[150px]">
                        </div>
                    </div>
                    <h5 class="font-semibold text-[18px] mt-10 text-gray-700">
                        Gym Facilities
                    </h5>
                    <p class="mt-8 text-gray-800">
                        Nowadays, stress and bad eating habits downgrade our health, and at ARNI, we do not compromise
                        with the health of our students. We offer gym facilities for both students and faculty to ensure
                        a healthy lifestyle. We have a separate gym schedule for both boys and girls to maintain comfort
                        and discipline. Along with fitness equipment for strength training, cardio, and endurance
                        workouts, we also offer professional trainers who are available to guide and help individuals
                        reach their fitness goals safely and effectively.
                    </p>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
                        <div *ngFor="let image of gymImages">
                            <img [src]="image.image_url" [alt]="image.name"
                                 class="w-full object-cover border h-[150px]">
                        </div>
                    </div>
                    <h5 class="font-semibold text-xl mt-10 text-gray-700">
                        Medical Facilities
                    </h5>
                    <p class="mt-8 text-gray-800">
                        At ARNI University, we prioritize the health and well-being of our students and staff. Our
                        campus includes dedicated medical facilities to offer primary healthcare services and routine
                        check-ups. We have a doctor’s room, two Wards, along with 5 beds in each room, and required
                        medical accessories/instruments (Stretcher, Wheelchairs etc.), ambulance service, etc. A trained
                        medical team including qualified doctors and nurses are available during working hours. In case
                        of serious medical needs, students are referred to the nearest advanced hospital with which the
                        university has tie-ups.
                    </p>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
                        <div *ngFor="let image of medicalFacilitiesImages">
                            <img [src]="image.image_url" [alt]="image.name"
                                 class="w-full object-cover border h-[150px]">
                        </div>
                    </div>
                    <h5 class="font-semibold text-xl mt-10 text-gray-700">
                        Emergency Transportation Facilities
                    </h5>
                    <p class="mt-8 text-gray-800">
                        Emergencies can arise at any moment, and to address such situations effectively, ARNI University
                        maintains a standby ambulance and dedicated transport service. These services ensure that
                        students and staff have quick and reliable access to medical aid and hospital facilities
                        whenever necessary. Our transportation team is trained to act swiftly and responsibly in any
                        emergency scenario.
                    </p>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
                        <div *ngFor="let image of transportationImages">
                            <img [src]="image.image_url" [alt]="image.name"
                                 class="w-full object-cover border h-[150px]">
                        </div>
                    </div>
                    <h5 class="font-semibold text-[18px] mt-10 text-gray-700">
                        Canteen Facilities
                    </h5>
                    <p class="mt-8 text-gray-800">
                        Having a good time with friends while eating tasty food is such a rejuvenating experience after
                        a day-long physical and mental learning. We believe that a satisfied appetite and taste buds
                        lead to a well-nourished mind. Our cafeteria is not just a place where the students eat; this is
                        the place to refresh, connect, and unwind thoughts and ideas. This is the place for meet, greet,
                        and gossiping that empowers personal connections and togetherness along with delicious foods and
                        beverages made with authenticity and proper hygiene. We have a list of diseases on our menu,
                        from healthy options such as milk, juice, and fruits to pizzas, shakes, chocolates, and many
                        more.
                    </p>
                    <!--<div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
                        <div *ngFor="let image of hostelImages">
                            <img [src]="image.image_url" [alt]="image.name"
                                 class="w-full object-cover border h-[150px]">
                        </div>
                    </div>-->
                </div>
                <div class="text-justify" *ngIf="pageTitle === 'Residential Facilities'">
                    <p class="mt-8 text-gray-800">Our students consider ARNI's hostels to be a second home since they
                        are secure and
                        clean. Our
                        lodging is the perfect spot for students because it offers round-the-clock security, hygienic
                        cuisine, and internet access. We provide well-furnished rooms, common areas, and a study space
                        in our three hostels for boys, which can accommodate 514 students, and one hostel for girls,
                        which can accommodate 171 students.
                    </p>
                    <h5 class="font-semibold text-[18px] mt-10 text-gray-700">
                        Hostel Facilities
                    </h5>
                    <p class="mt-8 text-gray-800">
                        ARNI University prioritizes a comfortable living environment for students, offering secure,
                        well-maintained hostels that provide a home-away-from-home experience. The hostels are
                        segregated for boys and girls, offering spacious, clean, and fully furnished accommodations in
                        single, double, and triple occupancy options. They are equipped with essential amenities like
                        24/7 CCTV surveillance, electricity backup, clean drinking water, and a hygienic dining setup.
                        Girls' safety and comfort are prioritized, with an overall hostel capacity of 714 students.
                    </p>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
                        <div *ngFor="let image of hostelImages">
                            <img [src]="image.image_url" [alt]="image.name"
                                 class="w-full object-cover border h-[150px]">
                        </div>
                    </div>
                    <h5 class="font-semibold text-[18px] mt-10 text-gray-700">
                        Mess Facilities
                    </h5>
                    <p class="mt-4 text-gray-800">
                        ARNI University prioritizes nutritious food for students' physical and academic well-being. The
                        university's mess facilities serve hygienic, balanced meals with a variety of seasonal
                        vegetables, pulses, and fruits. A dedicated team monitors food preparation and cleanliness
                        standards. Mess charges are collected in advance at the beginning of each semester. The
                        university houses two dining halls for boys and girls, accommodating 300 students comfortably.
                        These facilities also serve as social spaces for students to connect and build friendships.
                        Additionally, ARNI University provides furnished residential quarters for faculty and a guest
                        house for visitors.
                    </p>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
                        <div *ngFor="let image of messImages">
                            <img [src]="image.image_url" [alt]="image.name"
                                 class="w-full object-cover border h-[150px]">
                        </div>
                    </div>
                </div>
                <div *ngIf="pageTitle === 'Schools'">
                    <p class="mt-8 text-justify text-gray-800">
                        ARNI University offers the best education through a diverse range of divisions commonly known as
                        ARNI Schools. From engineering and technology to arts, finance, business, sports, and health
                        sciences, ARNI is dedicated to fostering educational excellence in numerous fields, including
                        education, research, and innovation.
                    </p>
                    <p class="mt-8 text-justify text-gray-800">
                        With an aim to interdisciplinary learning, the university has specialized schools that cater to
                        numerous fields of study, ensuring each and every student receives a well-rounded and
                        industry-oriented education as per their area of interest and professional goals.
                    </p>
                    <p class="mt-8 text-justify text-gray-800">ARNI University has 10 schools aiming to provide a
                        quality education,
                        led by distinguished faculty members and industry experts. The schools offer several
                        undergraduate, postgraduate, diploma, and doctoral degrees in various specializations. The
                        university's immense size and scope create remarkable opportunities for multidisciplinary
                        projects and teamwork, giving academic staff and students the chance to do great things.
                    </p>
                    <p class="mt-8 text-justify text-gray-800">The curriculum for each course is carefully designed with
                        the latest
                        trends under the guidance of highly passionate faculty members and industry experts to infuse
                        robust skills among the students, preparing graduates to excel in their respective fields.
                        Moreover, the blend of theoretical and practical learning pushes students to think beyond the
                        classroom, ensuring the active participation of students, teachers, and administration.
                    </p>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 py-12 gap-8"
                         *ngIf="pageTitle === 'Schools'">
                        <a
                            class="bg-white w-full shadow-lg border pb-6 hover:shadow-xl transition duration-300"
                            *ngFor="let school of schools"
                            [href]="school.url"
                        >
                            <div>
                                <img [src]="school.image_url" class="w-full h-auto" [alt]="school.name"/>
                            </div>
                            <h6 class="font-semibold text-xl pt-8 pb-6 px-4">
                                {{ school.name }}
                                <div class="bg-gold h-[2px] w-[32%]"></div>
                            </h6>
                            <p class="px-4 line-clamp-3 text-justify">
                                {{ school.description }}
                            </p>
                        </a>
                    </div>

                </div>
                <div class="text-justify" *ngIf="pageTitle === 'Transportation'">
                    <p class="mt-8 text-gray-800">
                        Commuting through safe transportation is essential for a stress-free and productive academic
                        experience. At ARNI University, we have established a well-managed and student-friendly
                        transport facility that ensures the safety, comfort, and punctuality of the students and faculty
                        members. Whether it’s about attending regular classes or commuting to college daily, taking part
                        in extracurricular activities, or going home for weekends, our bus service ensures a smooth and
                        secure journey every day.
                    </p>
                    <p class="mt-8 text-gray-800">Our university-operated fleet of vehicles covers a wide network across
                        the nearby
                        regions of
                        Himachal Pradesh, Punjab, and Jammu & Kashmir. These vehicles are not only comfortable but also
                        fully equipped with essential safety features such as GPS tracking systems and first-aid kits,
                        ensuring peace of mind for students and their families.
                    </p>
                    <p class="mt-8">Our Current Routes Include:</p>
                    <ul class="list-disc ml-6 mt-2 text-gray-800">
                        <li>
                            <ul>
                                <li class="font-semibold"><span class="text-xl">🚌</span> Bus No: HP 38 E 0114</li>
                                <li>🟢 Malikpur ⇄ Arni University</li>
                                <li><span class="text-xl">🚌</span> Malikpur ↔️ Chaki Bridge ↔️
                                    Damtal ↔️ Nangal Bhur ↔️ Mirthal ↔️ Kathgarh ↔️ Arni
                                    University 📍
                                </li>
                            </ul>
                        </li>
                        <li class="my-4">
                            <ul>
                                <li class="font-semibold"><span class="text-xl">🚌</span> Bus No: HP 38 E 0115</li>
                                <li>🟢 Route: Jawali ⇄ Arni University</li>
                                <li><span class="text-xl">🚌</span> Jawali ↔️ Mehra Fatak ↔️ Bharmar ↔️ Nial ↔️ Harnota
                                    Fatak ↔️ Raja Ka Talab ↔️
                                    Jassur ↔️ Arni University 📍
                                </li>
                            </ul>
                        </li>
                        <li>
                            <ul>
                                <li class="font-semibold"><span class="text-xl">🚌</span> Bus No: HP 97 A 7201</li>
                                <li>🟢 Amroh ⇄ Arni University</li>
                                <li><span class="text-xl">🚌</span> Amroh ↔️ Sansarpur Terrace ↔️ Talwara ↔️ Chir Di Khoo
                                    ↔️ Hajipur ↔️ Budhabarh ↔️
                                    Thakurdwara ↔️ Bakradwan ↔️ Arni University 📍
                                </li>
                            </ul>
                        </li>
                        <li class="my-4">
                            <ul>
                                <li class="font-semibold">🚌<span class="text-xl">🚌</span> Bus No: HP 97 A 7021</li>
                                <li>🟢 Dasuya ⇄ Arni University</li>
                                <li><span class="text-xl">🚌</span> Dasuya ↔️ Unchi Bassi ↔️ Mukerian ↔️ Bhangala ↔️
                                    Jandwal ↔️ Mansar ↔️ Mirthal ↔️
                                    Kathgarh ↔️ Arni University 📍
                                </li>
                            </ul>
                        </li>
                        <li>
                            <ul>
                                <li class="font-semibold"><span class="text-xl">🚌</span> Bus No: HP 97 A 7102</li>
                                <li>🟢 Darkati ⇄ Arni University</li>
                                <li><span class="text-xl">🚌</span> Darkati ↔️ Ludhiar ↔️ Sidhpur Ghad ↔️ Bharmar ↔️
                                    Kandhor ↔️ Rehan ↔️ Betoli ↔️
                                    Sardial
                                    ↔️ Gadhrana ↔️ Dini Larth ↔️ Sanihal ↔️ Malahri ↔️ Indora Barrier ↔️ Arni University
                                    📍
                                </li>
                            </ul>
                        </li>
                        <li class="my-4">
                            <ul>
                                <li class="font-semibold"><span class="text-xl">🚌</span> Bus No: HP 97 A 6004</li>
                                <li>🟢 Raja Ka Talab ⇄ Arni University</li>
                                <li><span class="text-xl">🚌</span> Raja Ka Talab ↔️ Talara ↔️ Ganoh ↔️ Aghar Ka Talab ↔️
                                    Gangath ↔️ Attara Bridge ↔️
                                    Changara ↔️ Kaptial ↔️ Sauhara ↔️ Indpur ↔️ Indora ↔️ Arni University📍
                                </li>
                            </ul>
                        </li>
                        <li>
                            <ul>
                                <li class="font-semibold"><span class="text-xl">🚌</span> Bus No: HP 97 A 6103</li>
                                <li>🟢 Route: Jakhbad ⇄ Arni University</li>
                                <li><span class="text-xl">🚌</span> Jakhbad ↔️ Rey ↔️ Bhadukhar ↔️ Indora Barrier ↔️ Arni
                                    University 📍
                                </li>
                            </ul>
                        </li>
                        <li class="my-4">
                            <ul>
                                <li class="font-semibold"><span class="text-xl">🚌</span> Bus No: HP 97 A 6301</li>
                                <li>🟢 Route: Dyoli ⇄ Arni University</li>
                                <li><span class="text-xl">🚌</span> Dyoli ↔️ Sulali ↔️ Simbli ↔️ Sadwan ↔️ Hindora Gharat
                                    ↔️ Nurpur ↔️ Jassur ↔️
                                    Kandwan
                                    ↔️ Lodawan ↔️ Gagwal ↔️ Badroya ↔️ Damtal ↔️ Surajpur ↔️ Malot ↔️ Dahlulara ↔️
                                    Changara
                                    ↔️ Bapoo ↔️ Indora ↔️ Arni University 📍
                                </li>
                            </ul>
                        </li>
                        <li>
                            <ul>
                                <li class="font-semibold"><span class="text-xl">🚌</span> Bus No: HP 97 A 8110</li>
                                <li>🟢 Route: Dhameta (Chatta) ⇄ Arni University</li>
                                <li><span class="text-xl">🚌</span> Dhameta (Chatta) ↔️ Fatehpur ↔️ Rehan ↔️ Chattar ↔️
                                    Gheta ↔️ Gangath ↔️ Attara
                                    Bridge
                                    ↔️ Changara ↔️ Kaptial ↔️ Sauhara ↔️ Indpur ↔️ Indora ↔️ Arni University 📍
                                </li>
                            </ul>
                        </li>
                        <li class="my-4">
                            <ul>
                                <li class="font-semibold"><span class="text-xl">🚌</span> Bus No: PB 35 AP 3421</li>
                                <li>🟢 Route: Madhopur Tharyal ⇄ Arni University</li>
                                <li><span class="text-xl">🚌</span> Madhopur Tharyal ↔️ Khanpur Chowk ↔️ Pangoli ↔️ Mamun
                                    Cantt ↔️ Simbal Chowk ↔️
                                    Chaki
                                    Bridge ↔️ Damtal ↔️ Kandrori ↔️ Indora ↔️ Arni University 📍
                                </li>
                            </ul>
                        </li>
                        <li>
                            <ul>
                                <li class="font-semibold"><span class="text-xl">🚌</span> Bus No: PB 35 AP 3412</li>
                                <li>🟢 Route: Bhadukhar ⇄ Arni University</li>
                                <li><span class="text-xl">🚌</span> Bhadukhar ↔️ Malal ↔️ Palakhi ↔️ Bhogarwan ↔️ Moki Ka
                                    Talab ↔️ Sanour ↔️ Indora
                                    Bus
                                    Stand ↔️ Arni University 📍
                                </li>
                            </ul>
                        </li>
                    </ul>

                    <!--<ul class="list-disc ml-6 mt-2 text-gray-800">
                        <li>
                            Talwara – Mukerian – ARNI.
                        </li>
                        <li>
                            Kathua – Pathankot – ARNI
                        </li>
                        <li>
                            Bhadwar – Nurpur – ARNI.
                        </li>
                        <li>
                            Mehra Phatak – Gangath – ARNI.
                        </li>
                        <li>
                            Jawali – Indora – ARNI.
                        </li>
                        <li>
                            Dhameta – Rahan – ARNI.
                        </li>
                        <li>
                            Badukhar – Indora – ARNI.
                        </li>
                    </ul>-->

                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
                        <div *ngFor="let image of transportationImages">
                            <img [src]="image.image_url" [alt]="image.name"
                                 class="w-full object-cover border h-[150px]">
                        </div>
                    </div>
                    <p class="mt-8 text-gray-800">With ARNI University’s transportation services, students and faculty
                        members can
                        rest assured of
                        a safe, timely, and comfortable commute every single day. We are committed to creating an
                        environment where accessibility never becomes a barrier to learning.
                    </p>
                </div>
                <div class="text-justify aarni-font" *ngIf="pageTitle === 'Library'">
                    <div class="flex flex-wrap lg:gap-8">
                        <div class="w-full">
                            <h5 class="font-semibold text-[18px] mt-10 text-gray-700">
                                About the Library
                            </h5>
                            <p class="mt-4 text-justify text-gray-800">
                                AU Library caters to the information needs of the faculty members, students, research
                                scholars and staff. Library collection comprises printed documents such as books,
                                reports, theses, atlases and back volumes of journals. The non-print collections include
                                Books and Magazines, CDs. Library is a member of Developing Library Network (DELNET) for
                                sharing the resources among its member libraries. Library is housed in an
                                air-conditioned building for users to pursue their academic and research activities by
                                way of reading books, accessing electronic journals and internet etc. The Library is
                                automated using ERP Library Management Software.
                            </p>
                            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
                                <div *ngFor="let image of libraryImages">
                                    <img [src]="image.image_url" [alt]="image.name"
                                         class="w-full object-cover border h-[150px]">
                                </div>
                            </div>
                            <div class="w-full">
                                <h2 class="text-2xl font-bold mt-6 text-start">Librarians</h2>
                                <div class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-4 mt-6">
                                    <div *ngFor="let image of librarians" class="text-center">
                                        <img
                                            [src]="image.image"
                                            [alt]="image.name"
                                            class="w-full object-cover border h-[150px] mx-auto"
                                        />
                                        <p class="mt-2 font-semibold text-gray-800">{{ image.name }}</p>
                                        <p class="text-sm text-gray-600">({{ image.designation }})</p>
                                    </div>
                                </div>

                            </div>
                            <h5 class="font-semibold text-[18px] mt-4 text-gray-700">
                                Library Sections
                            </h5>
                            <ul class="list-disc px-5 text-gray-800">
                                <li>Circulation Section</li>
                                <li>Technical Section</li>
                                <li>Acquisition Section</li>
                                <li>Periodical Section</li>
                                <li>Newspaper Corner</li>
                            </ul>
                            <h5 class="font-semibold text-[18px] mt-4 text-gray-700">
                                Library Collections
                            </h5>
                            <p class="mt-4 text-gray-800">
                                The library collection consists of Books, Reference Books, Text Books, Print Journals,
                                Newspapers, Donated Books, E-Journals & Databases, and CD ROM/DVDs.
                            </p>
                            <div class="mt-4 overflow-x-auto border-gray-600 max-w-[300px] md:max-w-2xl">
                                <table class="min-w-full table-auto border border-gray-300 mt-2 text-gray-800">
                                    <thead class="bg-gray-200">
                                    <tr>
                                        <th class="border border-gray-300 px-4 py-2 text-left">Sl.No</th>
                                        <th class="border border-gray-300 px-4 py-2 text-left">Resources</th>
                                        <th class="border border-gray-300 px-4 py-2 text-left">Total</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td class="border border-gray-300 px-4 py-2">1.</td>
                                        <td class="border border-gray-300 px-4 py-2">Books</td>
                                        <td class="border border-gray-300 px-4 py-2">25000+</td>
                                    </tr>
                                    <tr>
                                        <td class="border border-gray-300 px-4 py-2">2.</td>
                                        <td class="border border-gray-300 px-4 py-2">Journals and Print Format</td>
                                        <td class="border border-gray-300 px-4 py-2">30+</td>
                                    </tr>
                                    <tr>
                                        <td class="border border-gray-300 px-4 py-2">3.</td>
                                        <td class="border border-gray-300 px-4 py-2">E-Journals</td>
                                        <td class="border border-gray-300 px-4 py-2">1000+</td>
                                    </tr>
                                    <tr>
                                        <td class="border border-gray-300 px-4 py-2">4.</td>
                                        <td class="border border-gray-300 px-4 py-2">Thesis and Dissertation</td>
                                        <td class="border border-gray-300 px-4 py-2">1500+</td>
                                    </tr>
                                    <tr>
                                        <td class="border border-gray-300 px-4 py-2">5.</td>
                                        <td class="border border-gray-300 px-4 py-2">News Papers</td>
                                        <td class="border border-gray-300 px-4 py-2">15</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <h5 class="font-semibold text-[18px] mt-4 text-gray-700">
                                E-Learning Portal
                            </h5>
                            <div class="mt-4 overflow-x-auto border-gray-600 max-w-[300px] md:max-w-2xl">
                                <table class=" table-auto border border-gray-300 mt-2">
                                    <thead class="bg-gray-200">
                                    <tr>
                                        <th class="border px-4 py-2 text-left">Sl. No</th>
                                        <th class="border px-4 py-2 text-left">E-Resources</th>
                                        <th class="border px-4 py-2 text-left">Website Link</th>
                                    </tr>
                                    </thead>
                                    <tbody class="text-sm">
                                    <tr>
                                        <td class="border px-4 py-2">01.</td>
                                        <td class="border px-4 py-2">Aggregated Video: Academic Earth</td>
                                        <td class="border px-4 py-2"><a href="http://www.academicearth.org"
                                                                        class="text-blue-600 underline" target="_blank">academicearth.org</a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">02.</td>
                                        <td class="border px-4 py-2">Berkeley University</td>
                                        <td class="border px-4 py-2"><a href="http://ocw.uci.edu"
                                                                        class="text-blue-600 underline" target="_blank">ocw.uci.edu</a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">03.</td>
                                        <td class="border px-4 py-2">Carnegie Mellon University</td>
                                        <td class="border px-4 py-2"><a href="http://www.cmu.edu/oli"
                                                                        class="text-blue-600 underline" target="_blank">cmu.edu/oli</a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">04.</td>
                                        <td class="border px-4 py-2">John Hopkins University</td>
                                        <td class="border px-4 py-2"><a href="http://ocw.jhsph.edu"
                                                                        class="text-blue-600 underline" target="_blank">ocw.jhsph.edu</a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">05.</td>
                                        <td class="border px-4 py-2">e-kutumb AICTE/UGC books</td>
                                        <td class="border px-4 py-2"><a href="https://ekumbh.aicte-india.org/"
                                                                        class="text-blue-600 underline" target="_blank">ekumbh.aicte-india.org</a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">06.</td>
                                        <td class="border px-4 py-2">MIT</td>
                                        <td class="border px-4 py-2">
                                            <p class="text-blue-600 space-y-1">
                                                <a href="http://techtv.mit.edu" class="text-blue-600 underline"
                                                   target="_blank">techtv.mit.edu</a>
                                                <a href="http://ocw.mit.edu" class="text-blue-600 underline"
                                                   target="_blank">ocw.mit.edu</a>
                                                <a href="http://video.mit.edu/" class="text-blue-600 underline"
                                                   target="_blank">video.mit.edu</a>
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">07.</td>
                                        <td class="border px-4 py-2">Mixed Media: Wikimedia</td>
                                        <td class="border px-4 py-2">
                                            <p class="text-blue-600">
                                                <a href="http://en.wikipedia.org/wiki/Mixed_media" class="underline"
                                                   target="_blank">en.wikipedia.org/wiki/Mixed_media</a>
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">08.</td>
                                        <td class="border px-4 py-2">National Repository of Open Education Resources
                                        </td>
                                        <td class="border px-4 py-2">
                                            <p class="text-blue-600">
                                                <a href="http://nroer.gov.in/home/" class="underline" target="_blank">nroer.gov.in/home</a>
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">09.</td>
                                        <td class="border px-4 py-2">NDLI</td>
                                        <td class="border px-4 py-2">
                                            <p class="text-blue-600">
                                                <a href="https://ndl.iitkgp.ac.in/" class="underline" target="_blank">ndl.iitkgp.ac.in</a>
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">10.</td>
                                        <td class="border px-4 py-2">NPTEL</td>
                                        <td class="border px-4 py-2">
                                            <p class="text-blue-600">
                                                <a href="https://www.youtube.com/nptelhrd" class="underline"
                                                   target="_blank">youtube.com/nptelhrd</a>,
                                                <a href="http://nptel.iitk.ac.in/" class="underline" target="_blank">nptel.iitk.ac.in</a>
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">11.</td>
                                        <td class="border px-4 py-2">OER Commons</td>
                                        <td class="border px-4 py-2">
                                            <p class="text-blue-600">
                                                <a href="https://www.oercommons.org" class="underline" target="_blank">oercommons.org</a>
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">12.</td>
                                        <td class="border px-4 py-2">Online College Courses</td>
                                        <td class="border px-4 py-2">
                                            <p class="text-blue-600">
                                                <a href="https://www.onlinecourses.com" class="underline"
                                                   target="_blank">onlinecourses.com</a>
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">13.</td>
                                        <td class="border px-4 py-2">Online College Courses (Subject wise)</td>
                                        <td class="border px-4 py-2">
                                            <p class="text-blue-600 space-y-1">
                                                <a href="http://www.onlinecourses.com/accounting/"
                                                   class="underline block" target="_blank">Accounting</a>
                                                <a href="http://www.onlinecourses.com/math/" class="underline block"
                                                   target="_blank">Math</a>
                                                <a href="http://www.onlinecourses.com/science/" class="underline block"
                                                   target="_blank">Science</a>
                                                <a href="http://www.onlinecourses.com/information-technology/"
                                                   class="underline block" target="_blank">Information Technology</a>
                                                <a href="http://www.onlinecourses.com/physics/" class="underline block"
                                                   target="_blank">Physics</a>
                                                <a href="http://www.onlinecourses.com/writing/" class="underline block"
                                                   target="_blank">Writing</a>
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">14.</td>
                                        <td class="border px-4 py-2">Open Access Research : (DOAJ)</td>
                                        <td class="border px-4 py-2">
                                            <p class="text-blue-600">
                                                <a href="https://www.doaj.org" class="underline" target="_blank">doaj.org</a>
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">15.</td>
                                        <td class="border px-4 py-2">Open Courseware Consortium</td>
                                        <td class="border px-4 py-2">
                                            <p class="text-blue-600">
                                                <a href="http://www.ocwconsortium.org/" class="underline"
                                                   target="_blank">ocwconsortium.org</a>
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">16.</td>
                                        <td class="border px-4 py-2">Open Courseware Mexico</td>
                                        <td class="border px-4 py-2">
                                            <p class="text-blue-600">
                                                <a href="http://ocw.itesm.mx" class="underline" target="_blank">ocw.itesm.mx</a>
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">17.</td>
                                        <td class="border px-4 py-2">Open Culture</td>
                                        <td class="border px-4 py-2">
                                            <p class="text-blue-600">
                                                <a href="http://www.openculture.com/freeonlinecourses" class="underline"
                                                   target="_blank">openculture.com/freeonlinecourses</a>
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">18.</td>
                                        <td class="border px-4 py-2">Open Learn</td>
                                        <td class="border px-4 py-2">
                                            <p class="text-blue-600">
                                                <a href="http://www.open.ac.uk/openlearn/home.php" class="underline"
                                                   target="_blank">open.ac.uk/openlearn/home.php</a>
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">19.</td>
                                        <td class="border px-4 py-2">Open Learning Object Repository : (Merlot)</td>
                                        <td class="border px-4 py-2">
                                            <p class="text-blue-600">
                                                <a href="http://www.merlot.org/merlot/materials.htm?materialType=Learning%20Object%20Repository&amp;category=372822&amp;sort.property=overallRating"
                                                   class="underline" target="_blank">merlot.org (Learning Object
                                                    Repository)</a>
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">20.</td>
                                        <td class="border px-4 py-2">Open Michigan</td>
                                        <td class="border px-4 py-2">
                                            <p class="text-blue-600">
                                                <a href="https://open.umich.edu/" class="underline" target="_blank">open.umich.edu</a>
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">21.</td>
                                        <td class="border px-4 py-2">Open Textbooks For K12: (Siyavula)</td>
                                        <td class="border px-4 py-2">
                                            <p class="text-blue-600">
                                                <a href="http://www.siyavula.com/" class="underline" target="_blank">siyavula.com</a>
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">22.</td>
                                        <td class="border px-4 py-2">Open Textbooks: (Connexions)</td>
                                        <td class="border px-4 py-2">
                                            <p class="text-blue-600">
                                                <a href="http://cnx.org" class="underline" target="_blank">cnx.org</a>
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">23.</td>
                                        <td class="border px-4 py-2">Open University of Nederland</td>
                                        <td class="border px-4 py-2">
                                            <p class="text-blue-600">
                                                <a href="http://ocw.tudelft.nl" class="underline" target="_blank">ocw.tudelft.nl</a>
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">24.</td>
                                        <td class="border px-4 py-2">Paris Tech Graduate School</td>
                                        <td class="border px-4 py-2">
                                            <p class="text-blue-600">
                                                <a href="http://graduateschool.paristech.org" class="underline"
                                                   target="_blank">graduateschool.paristech.org</a>
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">25.</td>
                                        <td class="border px-4 py-2">PG-Pathshala</td>
                                        <td class="border px-4 py-2">
                                            <p class="text-blue-600">
                                                <a href="https://epgp.inflibnet.ac.in/" class="underline"
                                                   target="_blank">epgp.inflibnet.ac.in</a>
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">26.</td>
                                        <td class="border px-4 py-2">Rai Open Courseware</td>
                                        <td class="border px-4 py-2">
                                            <p><a href="http://www.rocw.railfoundation.org"
                                                  class="text-blue-600 underline" target="_blank">rocw.railfoundation.org</a>
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">27.</td>
                                        <td class="border px-4 py-2">Swayam: Massive Open Online Courses</td>
                                        <td class="border px-4 py-2">
                                            <p><a href="https://swayam.gov.in/" class="text-blue-600 underline"
                                                  target="_blank">swayam.gov.in</a></p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">28.</td>
                                        <td class="border px-4 py-2">Sakshat Portal</td>
                                        <td class="border px-4 py-2">
                                            <p><a href="http://www.sakshat.ac.in/" class="text-blue-600 underline"
                                                  target="_blank">sakshat.ac.in</a></p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">29.</td>
                                        <td class="border px-4 py-2">Spoken Tutorial</td>
                                        <td class="border px-4 py-2">
                                            <p><a href="http://www.spoken-tutorial.org" class="text-blue-600 underline"
                                                  target="_blank">spoken-tutorial.org</a></p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">30.</td>
                                        <td class="border px-4 py-2">Teacher Portal (Class Room Resources)</td>
                                        <td class="border px-4 py-2">
                                            <p><a href="http://www.teachersofindia.org/en"
                                                  class="text-blue-600 underline"
                                                  target="_blank">teachersofindia.org/en</a></p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">31.</td>
                                        <td class="border px-4 py-2">Tufts Open Courseware</td>
                                        <td class="border px-4 py-2">
                                            <p><a href="http://ocw.tufts.edu" class="text-blue-600 underline"
                                                  target="_blank">ocw.tufts.edu</a></p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">32.</td>
                                        <td class="border px-4 py-2">United Nations University</td>
                                        <td class="border px-4 py-2">
                                            <p><a href="http://www.ocw.unu.edu" class="text-blue-600 underline"
                                                  target="_blank">ocw.unu.edu</a></p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">33.</td>
                                        <td class="border px-4 py-2">University of Minnesota (Open Academics Textbook
                                            Catalogue)
                                        </td>
                                        <td class="border px-4 py-2">
                                            <p><a href="https://open.umn.edu/opentextbooks/"
                                                  class="text-blue-600 underline" target="_blank">open.umn.edu/opentextbooks</a>
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">34.</td>
                                        <td class="border px-4 py-2">University of Notre Dame</td>
                                        <td class="border px-4 py-2">
                                            <p><a href="http://ocw.nd.edu" class="text-blue-600 underline"
                                                  target="_blank">ocw.nd.edu</a></p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">35.</td>
                                        <td class="border px-4 py-2">University of Southern Queensland</td>
                                        <td class="border px-4 py-2">
                                            <p><a href="http://ocw.usq.edu.au/" class="text-blue-600 underline"
                                                  target="_blank">ocw.usq.edu.au</a></p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">36.</td>
                                        <td class="border px-4 py-2">Utah Open Courseware Alliance</td>
                                        <td class="border px-4 py-2">
                                            <p><a href="http://uocwa.org" class="text-blue-600 underline"
                                                  target="_blank">uocwa.org</a></p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">37.</td>
                                        <td class="border px-4 py-2">Utah State University</td>
                                        <td class="border px-4 py-2">
                                            <p><a href="http://ocw.usw.edu" class="text-blue-600 underline"
                                                  target="_blank">ocw.usw.edu</a></p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">38.</td>
                                        <td class="border px-4 py-2">Vietnam</td>
                                        <td class="border px-4 py-2">
                                            <p><a href="http://ocw.vn/index.ocw" class="text-blue-600 underline"
                                                  target="_blank">ocw.vn/index.ocw</a></p>
                                            <p><a href="http://ocw.fetp.edu.vn/home.cfm" class="text-blue-600 underline"
                                                  target="_blank">ocw.fetp.edu.vn/home.cfm</a></p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">39.</td>
                                        <td class="border px-4 py-2">Webcast.Berkeley</td>
                                        <td class="border px-4 py-2">
                                            <p><a href="http://webcast.berkeley.edu/" class="text-blue-600 underline"
                                                  target="_blank">webcast.berkeley.edu</a></p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">40.</td>
                                        <td class="border px-4 py-2">World Lecture Project</td>
                                        <td class="border px-4 py-2">
                                            <p><a href="http://www.world-lecture-project.org/?navId=1"
                                                  class="text-blue-600 underline" target="_blank">world-lecture-project.org</a>
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">41.</td>
                                        <td class="border px-4 py-2">Yale University</td>
                                        <td class="border px-4 py-2">
                                            <p><a href="http://oyc.yale.edu" class="text-blue-600 underline"
                                                  target="_blank">oyc.yale.edu</a></p>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <h5 class="font-semibold text-[18px] mt-4 text-gray-700">
                                Library Infrastructure
                            </h5>
                            <div class="mt-4 overflow-x-auto border-gray-600 max-w-[300px] md:max-w-2xl">
                                <table class="table-auto border-collapse w-full border border-gray-300 text-gray-800">
                                    <thead class="bg-gray-100">
                                    <tr>
                                        <th class="border border-gray-300 px-4 py-2">Sl.No</th>
                                        <th class="border border-gray-300 px-4 py-2">Particulars</th>
                                        <th class="border border-gray-300 px-4 py-2">Total Numbers</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td class="border border-gray-300 px-4 py-2">1.</td>
                                        <td class="border border-gray-300 px-4 py-2">Computers</td>
                                        <td class="border border-gray-300 px-4 py-2">34</td>
                                    </tr>
                                    <tr>
                                        <td class="border border-gray-300 px-4 py-2">2.</td>
                                        <td class="border border-gray-300 px-4 py-2">Printers</td>
                                        <td class="border border-gray-300 px-4 py-2">2</td>
                                    </tr>
                                    <tr>
                                        <td class="border border-gray-300 px-4 py-2">3.</td>
                                        <td class="border border-gray-300 px-4 py-2">Bar code scanner</td>
                                        <td class="border border-gray-300 px-4 py-2">2</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <h5 class="font-semibold text-[18px] mt-4 text-gray-700">
                                Library owned local host webpage
                            </h5>
                            <!--  <p class="mt-4 text-gray-800">
                                  To access multiple useful links on a single platform click here
                                  <a href="http://192.168.0.5:9000" target="_blank" class="text-blue-500 underline">http://192.168.0.5:9000</a>
                              </p>-->
                            <h5 class="font-semibold text-[18px] mt-4 text-gray-700">
                                Library OPAC
                            </h5>
                            <p class="mt-4 text-gray-800">
                                OPAC is the Online Public Access Catalogue. It is an online database of all of the
                                resources available in the library. Users can search OPAC to locate books in the
                                library. It lists the number of the items, whether they are in the library or out on
                                loan, and their location.
                            </p>
                            <!--      <p class="my-2 w-full">To access Library OPAC Click here
                                      <a
                                          href="http://172.16.2.9/40/library/webopac" target="_blank"
                                          class="text-blue-500 underline w-full">webopac.aspx</a>
                                  </p>-->
                            <h5 class="font-semibold text-[18px] mt-4 text-gray-700">
                                General Rules for maintenance and discipline in the library premises
                            </h5>
                            <p class="my-4 text-gray-800">The following rules and discipline measures are prescribed for
                                general
                                maintenance and discipline within the library premises.</p>
                            <ul class="list-disc px-5 text-gray-800">
                                <li>Library members shall maintain perfect silence, peace, order and calm environment
                                    conducive to concentrate on study.
                                </li>
                                <li>Smoking, spitting, consumption of food, drug, intoxicants, sleeping, whispering,
                                    murmuring, carrying of pets shall not be permitted in the library.
                                </li>
                                <li>Carrying of fire arms, explosives or any other objectionable material, literature by
                                    member is strictly prohibited.
                                </li>
                                <li>As a moral obligation each member shall require to keep the document neat, clean and
                                    in good condition.
                                </li>
                                <li>Before leaving the library, readers shall return to the assistant at the counter any
                                    document which they had taken for consultation.
                                </li>
                                <li>No personal belongings such as bags, briefcases, handbags, walking sticks, personal
                                    books, umbrella, parcels etc. are allowed inside the library. These belongings may
                                    be deposited at the property counter near the entrance gate meant for the purpose
                                    solely at users own risk and responsibility. Use of mobile phones in the library is
                                    strictly prohibited & members are also required to keep their mobiles on vibration /
                                    silent mode.
                                </li>
                                <li>Cases of incivility or other failure in service should be immediately reported to
                                    the Librarian.
                                </li>
                                <li>Circulation counter will start functioning from the time when library opens and
                                    closes half an hour before the normal office working hours.
                                </li>
                                <li>Charges shall be collected up to 4:00 P.M. on working days only.</li>
                                <li>Library users are required to vacate the premises 15 minutes before the closing time
                                    to enable shelving of the material, library staff to put off lights and other
                                    related jobs.
                                </li>
                                <li>All communications should be addressed to Librarian/In-charge.</li>
                                <li>Change of address, designation or contact number should be reported immediately in
                                    writing.
                                </li>
                                <li>Library staff / attendant is authorized to search any person on entry/exit point of
                                    the library.
                                </li>
                                <li>Members are not allowed to stand in groups in the library premises.</li>
                                <li>Every member must always possess identity card/library card and he should produce it
                                    whenever called upon to do so by the concerned library authority.
                                </li>
                                <li>A member should read the notices placed on the Library notice board. The library
                                    accepts no responsibility for the loss of any benefit by a member on account of his
                                    failure to read the notice in time.
                                </li>
                                <li>Members should behave decently in the premises of the library.</li>
                                <li>The infringement of rules may deprive a reader/borrower of the membership of the
                                    library for a specific period as per the order of the Librarian.
                                </li>
                                <li>Borrowers must return the book on or before the due date so as to enable the library
                                    to serve the maximum number of readers.
                                </li>
                                <li>Delay fine will be charged for each day the book is kept overdue or service to the
                                    defaulting member shall be curtailed proportionately.
                                </li>
                                <li>Marking or writing on the pages of the books with ink or pencil, tearing off or
                                    taking the pages or otherwise damaging will constitute an offence which is
                                    punishable as per rules.
                                </li>
                                <li>Unless a borrower points out, at the time of borrowing, the bad condition, if any,
                                    of the book, he shall be held strictly responsible for any damage and shall be
                                    required to replace the book or pay its price together with extra fine.
                                </li>
                                <li>Only light writing material is allowed inside the library.</li>
                                <li>Doing anything which may disturb other readers or which may be against the
                                    discipline of the institution is strictly prohibited.
                                </li>
                                <li>No person entitled or permitted to use the library shall mutilate, disfigure, deface
                                    by writing in the margins or by damaging in any other way a book, periodical, map,
                                    chart, or any other property of the library.
                                </li>
                                <li>If books issued to a member are found mutilated at the time of return, he/she shall
                                    have to replace or pay the replacement price as per rules of the same. Therefore,
                                    members are required to examine the books, etc., at the time of loan as the last
                                    borrower will be held responsible for any damage.
                                </li>
                                <li>No tracing or mechanical reproduction of any book, map, or manuscript shall be made
                                    without the prior permission of the Librarian.
                                </li>
                                <li>The Librarian reserves the right to suspend/cancel the membership privileges of any
                                    member found misbehaving with the library staff or for any other indecent behaviour.
                                    Such a member is also liable to be expelled from the library by the order of the
                                    Librarian.
                                </li>
                                <li>When students have any complaint about the service being provided by the library,
                                    they should not enter into an argument with the library staff. They should bring it
                                    to the notice of the Librarian.
                                </li>
                                <li>The librarian is empowered to recall any library material at any time if necessity
                                    arises, especially at the time of stock verification.
                                </li>
                                <li>In all other matters such as interpretation of the Library Rules or for any other
                                    matter not covered under these rules, the Librarian’s decision shall be final and
                                    the Librarian shall have the power to take such action as he may deem fit.
                                </li>
                                <li>These Library Rules may be altered or amended or new rules may be added to the
                                    existing ones by the Competent Authority from time to time without notice to the
                                    members, and these rules or any alterations or amendments to them shall be effective
                                    and binding on all concerned when notified.
                                </li>
                                <li>Members violating any of the rules and regulations are liable to be punished by
                                    disciplinary action.
                                </li>
                            </ul>
                            <p class="my-4">For any queries, feedback and suggestions please write a mail to <a
                                href="mailto:library@arniuniversity.edu.in" class="text-blue-500">library@arniuniversity.edu.in</a>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="text-justify text-gray-800" *ngIf="pageTitle === 'Green Campus'">
                    <p class="mt-8">
                        At ARNI University, we are deeply committed to creating a sustainable and eco-friendly
                        environment for both the students and the wider community. Our Green Campus Policy is an
                        initiative that brings together responsible resource use, environmental stewardship, and the
                        education of future leaders on the importance of protecting the planet.
                    </p>
                    <p class="mt-8">By developing sustainable solutions for the environmental, social, and economic
                        requirements of
                        humanity, the Green Campus concept offers educational institutions the chance to rethink their
                        eco-friendly culture and establish new paradigms.
                    </p>
                    <h5 class="font-semibold text-xl mt-10 text-gray-700">
                        Objectives of the Go Green Program
                    </h5>
                    <ul class="list-disc pl-6">
                        <li>Establishing a Committee for Green Campus: The first step is to create a dedicated committee
                            within the organizational structure, which includes faculty, students, parents, non-teaching
                            staff, industry representatives, and alumni, to oversee and inspect green initiatives to
                            ensure fair practices.
                        </li>
                        <li>Integrate Sustainability into Institutional Planning: To create and develop a clean and
                            sustainable campus environment, incorporating ‘go green’ strategies into the university’s
                            planning and budgeting processes.
                        </li>
                        <li> To Promote Environmental Ethics and Awareness: To aware students, faculty, and the
                            surrounding community about environmental ethics, conducting awareness campaigns and
                            educational programs.
                        </li>
                        <li>Foster Community and Stakeholder Engagement: Engage students, faculty, staff, and external
                            stakeholders in green initiatives through programs like tree plantation drives, cleanliness
                            campaigns, and the establishment of an Enviro-Club.
                        </li>
                        <li>Link Green Initiatives with Academics: Emerge practical-based learning with environmental
                            activities to foster a culture of sustainability learning, along with academic excellence.
                        </li>
                        <li>Develop Strategic Plans for Sustainability: To promote sustainability, create and implement
                            strategic plans. Replacing conventional lights with energy-efficient LEDs and installing
                            solar power stations within the campus to save electricity.
                        </li>
                        <li>Conduct Regular Environmental Audits: Not only implement but also frequently oversee and
                            maintain the green campus initiatives is important. Thus, performing annual audits under the
                            guidance of dedicated faculty members ensures environmental safety and improvements.
                        </li>
                        <li>Implement Waste and Water Management Systems: Establish wastewater management and rainwater
                            harvesting systems to reduce water consumption and promote sustainability.
                        </li>
                    </ul>
                    <h5 class="font-semibold text-xl mt-10 text-gray-700">
                        Representatives of the Go Green Program:
                    </h5>
                    <ul class="list-disc pl-6">
                        <li>Principal of the Pharmacy and Paramedical Studies - <span class="font-semibold">Prof. Neeraj Bhandari - Chairman</span>
                        </li>
                        <li>IQAC Director - <span class="font-semibold">Dr. Raja Mannar – Secretary</span></li>
                        <li>Faculty Representative - <span class="font-semibold">Dr. Sunita – Nominated</span></li>
                        <li>Student Representative - <span
                            class="font-semibold">Mr. Karan Dhingra – General Secretary</span></li>
                        <li>Non-Teaching Staff Representative - <span class="font-semibold">Mr. Sohan Lal- Office Superintendent</span>
                        </li>
                        <li>Parent Representative - <span class="font-semibold">Mr. Naresh Malpotra</span></li>
                        <li>Industry Representative - <span
                            class="font-semibold">Dr. Subhasis Das, Director, Ardent Steel</span>
                        </li>
                        <li>Alumni Association - <span class="font-semibold">Mr. Trilochan Singh</span></li>
                    </ul>
                    <h5 class="font-semibold text-xl mt-10 text-gray-700">
                        Simple Energy Saving Tips for Campus & Beyond
                    </h5>
                    <p class="mt-8">
                        Saving energy is not just good for the environment—it’s also easy and smart! Here are some
                        simple steps we can all take at ARNI University (and at home too!) to reduce energy use and
                        promote sustainability:
                    </p>
                    <p class="font-bold my-2 text-gray-700">Power Down Smartly</p>
                    <ul class="list-disc pl-6">
                        <li>Enable sleep mode on your computer and monitor to save energy when idle.</li>
                        <li>Always turn off your monitor when stepping away from your desk.</li>
                        <li>Set your printers to energy-saving mode too!</li>
                    </ul>
                    <p class="font-bold my-2 text-gray-700">Lights Off = Energy Saved</p>
                    <ul class="list-disc pl-6">
                        <li>Use natural sunlight during the day instead of turning on lights.</li>
                        <li>Switch off lights in empty classrooms, halls, and conference rooms.</li>
                        <li> Say no to decorative lighting and switch to energy-efficient LEDs or CFL bulbs.</li>
                    </ul>
                    <p class="font-bold my-2 text-gray-700">Use Fans & ACs Wisely</p>
                    <ul class="list-disc pl-6">
                        <li>Turn on fans or ACs only when necessary.</li>
                        <li>Unplug devices that aren’t in use—like TVs, fridges, coffee makers, printers, and
                            chargers.
                        </li>
                    </ul>
                    <p class="font-bold my-2 text-gray-700">Shut Down, Don’t Just Log Off</p>
                    <ul class="pl-6 list-disc">
                        <li>If you're done for the day, shut down your system instead of just logging off.</li>
                    </ul>
                    <p class="font-bold my-2 text-gray-700">Major Green Campus Initiatives:</p>
                    <ul class="pl-6 list-disc">
                        <li>ISO Certification 9001:2008</li>
                        <li>Installation of Solar Power Station</li>
                        <li>Wastewater Management/ Rainwater harvesting</li>
                        <li>Development of Sewage Water Treatment Plant</li>
                        <li>Use of Micro-scale techniques</li>
                        <li>Sensor-based energy conservation</li>
                        <li>Displayed poster on E-waste Management</li>
                        <li>Maintenance of water bodies and distribution systems on the campus</li>
                        <li>MIS to make paperless administration</li>
                        <li>Plastic-free Campus</li>
                        <li>Tree Plantation Drive</li>
                        <li>Cleanliness Drive</li>
                        <li>Landscaping and gardens</li>
                        <li>Use of LEDs only</li>
                        <li>Digital Library/ E-Learning Centre</li>
                        <li>Organization of sensitization programs for the stakeholders</li>
                        <li>Establishment of Enviro-Club</li>
                        <li>Green, Environment, and Energy Audit conducted</li>
                        <li>Restricted entry of automobiles</li>
                        <li>No Vehicle Day observed</li>
                    </ul>
                    <p class="py-4">The Institute will make all the necessary efforts to involve the students, faculty,
                        and staff in
                        “Green Campus Initiatives” by designating the volunteers of Enviro Club, NSS & NCC cadets,
                        printing T-shirts/ Caps with the green campus initiative slogan specially designed for the
                        purpose.</p>
                </div>
                <div class="text-justify text-gray-800" *ngIf="pageTitle === 'NCC'">
                    <ng-container [ngSwitch]="selectedTab">
                        <div class="container mx-auto px-4 lg:px-6 xl:px-32" *ngSwitchCase="'home'">
                            <div class="grid grid-cols-1 md:grid-cols-5 gap-0 md:gap-4 items-start">
                                <div class="flex flex-col gap-4 col-span-1 text-center">
                                    <div>
                                        <div class="bg-primary-dark text-white px-2 py-1 rounded-t">Director General
                                        </div>
                                        <img src="assets/img/ncc-home/gen-gurbirpal-singh.jpg"
                                             alt="Lt. Gen. Gurbirpal Singh"
                                             class="rounded-b-lg shadow-md w-full object-cover md:h-[250px]"/>
                                        <p class="text-sm mt-1 text-gray-700 font-medium">Lt Gen Gurbirpal Singh, AVSM,
                                            VSM</p>
                                        <p class="text-sm text-gray-700 font-medium">DG, NCC Delhi</p>
                                    </div>
                                    <div>
                                        <div class="bg-primary-dark text-white px-2 py-1 rounded-t">Additional Director
                                            General
                                        </div>
                                        <img
                                            src="assets/img/ncc-home/jagdeep-singh-cheema-additional-director-general-shimla.jpg"
                                            alt="Maj. Gen. Jagdeep Singh Cheema"
                                            class="rounded-b-lg shadow-md w-full object-cover md:h-[250px]"/>
                                        <p class="text-sm mt-1 text-gray-700 font-medium">Major General Jagdeep Singh
                                            Cheema PVSM, AVSM, VSM</p>
                                        <p class="text-sm text-gray-700 font-medium">(ADG) of (NCC) DTE</p>
                                        <p class="text-sm text-gray-700 font-medium">(PHHP&C)</p>
                                    </div>
                                    <div>
                                        <div class="bg-primary-dark text-white px-2 py-1 rounded-t">Deputy Director
                                            General
                                        </div>
                                        <img src="assets/img/ncc-home/rohit-dutta-group-commander-shimla.jpg"
                                             alt="Col. Rohit Dutta"
                                             class="rounded-b-lg shadow-md w-full object-cover md:h-[250px]"/>
                                        <p class="text-sm mt-1 text-gray-700 font-medium">Brigadier Rohit Dutta, AVSM,
                                            VSM</p>
                                        <p class="text-sm text-gray-700 font-medium">Group Commander</p>
                                        <p class="text-sm text-gray-700 font-medium">HQ NCC Shimla</p>
                                    </div>
                                </div>
                                <div class="px-2 md:px-4 col-span-3">
                                    <h2 class="text-3xl font-bold text-[#003b29] mb-4">From the Incharge's Desk</h2>
                                    <p class="text-gray-700 leading-relaxed text-lg">
                                        The NCC is a responsive, learning, and continuously evolving organization that
                                        plays a vital role in shaping the character of the youth. It encourages cadets
                                        to develop a strong sense of patriotic commitment, motivating them to contribute
                                        actively to national development and service. Cadets are taught to respect and
                                        embrace the rich diversities of India—religion, language, culture, ethnicity,
                                        lifestyle, and habitat—thereby nurturing an inclusive and united national
                                        identity.

                                        <br><br>
                                        One of the key objectives of the NCC is to instill a deep sense of national
                                        unity and social cohesion among the cadets. It emphasizes the importance of
                                        participating in community development projects, disaster relief activities, and
                                        various social service programmes. Through this, cadets learn to be socially
                                        responsible and empathetic citizens.

                                        <br><br>
                                        The NCC also fosters essential values such as honesty, truthfulness,
                                        self-sacrifice, perseverance, and hard work. By engaging in structured training
                                        and activities, cadets experience a disciplined and regimented way of life that
                                        promotes punctuality, orderliness, smartness in appearance and behavior, respect
                                        for rightful authority, and a strong work ethic. These attributes significantly
                                        boost their self-confidence and prepare them for future leadership roles.

                                        <br><br>
                                        As a vibrant youth development movement, the National Cadet Corps holds enormous
                                        potential for nation-building. It offers a unique platform for the holistic
                                        development of young minds by encouraging Duty, Commitment, Dedication,
                                        Discipline, and Moral Values. These ideals empower cadets to become responsible,
                                        capable, and compassionate leaders who can make meaningful contributions to
                                        society.

                                        <br><br>
                                        The NCC provides exposure to a wide spectrum of activities, including military
                                        training, adventure sports, cultural exchange programs, and social service
                                        initiatives. Special emphasis is placed on Discipline, Social Responsibility,
                                        and Adventure Training, which not only build physical endurance but also
                                        strengthen character. Open to all regular students of schools and colleges on a
                                        voluntary basis, the NCC offers a transformative experience without imposing any
                                        obligation for active military service. It is an opportunity for the youth to
                                        grow, serve, and inspire.
                                    </p>
                                </div>
                                <div class="flex flex-col gap-4 col-span-1 text-center">
                                    <div>
                                        <div class="bg-primary-dark text-white px-2 py-1 rounded-t">Dr. Vivek Singh
                                        </div>
                                        <img src="assets/img/top-leadership/chancellor-arni.jpg" alt="Vivek Singh"
                                             class="rounded-b-lg shadow-md w-full object-cover h-[250px]"/>
                                        <p class="text-sm mt-1 font-medium text-gray-700">Dr. Vivek Singh</p>
                                        <p class="text-sm font-medium text-gray-700">Chancellor</p>
                                        <p class="text-sm font-medium text-gray-700">ARNI University</p>
                                    </div>
                                    <div>
                                        <div class="bg-primary-dark text-white px-2 py-1 rounded-t">Registrar, Arni
                                            University
                                        </div>
                                        <img src="assets/img/ncc-home/registrar-arni.jpg" alt="Registrar Arni"
                                             class="rounded-b-lg shadow-md w-full object-cover h-[250px]"/>
                                        <p class="text-sm mt-1 font-medium text-gray-700">Dr. Trilochan Singh</p>
                                        <p class="text-sm font-medium text-gray-700">(Registrar/Principal)</p>
                                        <p class="text-sm font-medium text-gray-700">NCC</p>
                                        <p class="text-sm font-medium text-gray-700">ARNI University</p>
                                    </div>
                                    <div>
                                        <div class="bg-primary-dark text-white px-2 py-1 rounded-t">CTO Rohit Kumar
                                        </div>
                                        <img src="assets/img/ncc-home/cto-rohit-kumar.jpeg" alt="CTO Rohit Kumar"
                                             class="rounded-b-lg shadow-md w-full object-cover h-[250px]"/>
                                        <p class="text-sm mt-1 font-medium text-gray-700">CTO Rohit Kumar</p>
                                        <p class="text-sm font-medium text-gray-700">NCC Officer</p>
                                        <p class="text-sm font-medium text-gray-700">ARNI University</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="container mx-auto px-4 lg:px-6 xl:px-32" *ngSwitchCase="'about'">
                            <div>
                                <h5 class="font-bold text-[#003b29] text-3xl mt-2 ">
                                    Aim
                                </h5>
                                <p class="my-4 text-gray-700">The ‘Aims’ of the NCC laid out in 1988 have stood the test
                                    of time and
                                    continue to meet the requirements expected of it in the current socio–economic
                                    scenario of the country. The NCC aims at developing character, comradeship,
                                    discipline, a secular outlook, the spirit of adventure and ideals of selfless
                                    service amongst young citizens. Further, it aims at creating a pool of organized,
                                    trained and motivated youth with leadership qualities in all walks of life, who will
                                    serve the Nation regardless of which career they choose. Needless to say, the NCC
                                    also provides an environment conducive to motivating young Indians to join the armed
                                    forces.
                                </p>
                            </div>
                            <div>
                                <h5 class="font-bold text-3xl mt-2 text-[#003b29] ">
                                    Motto of NCC
                                </h5>
                                <p class="my-4 text-gray-700">
                                    The need for having motto for the Corps was discussed in the 11th Central Advisory
                                    Committee (CAC) meeting held on 11 Aug 1978. The mottos suggested were "Duty and
                                    Discipline"; "Duty, Unity and Discipline"; "Duty and Unity"; "Unity and Discipline".
                                    The final decision for selection of "Unity and Discipline" as motto for the NCC was
                                    taken in the 12th CAC meeting held on 12 Oct 1980.
                                </p>
                            </div>
                            <div>
                                <h5 class="font-bold text-3xl mt-2 text-[#003b29]">
                                    NCC Flag
                                </h5>
                                <div class="flex flex-col md:flex-row md:items-start md:gap-6 my-4">
                                    <img src="assets/img/ncc-about/ncc-flag.png"
                                         class="rounded shadow-md w-full md:w-1/5 mb-4 md:mb-0"/>

                                    <p class="md:w-4/5 text-justify text-gray-700">
                                        The NCC flag for various units of the NCC was first introduced in 1951. The flag
                                        was
                                        of same pattern, colour and size as was used by various regiments of the Army.
                                        The
                                        only difference was that it had the NCC badge and unit designation placed in the
                                        centre.<br/> <br/> Later on it was felt that the flag should be in keeping with
                                        the
                                        inter-service character of the Corps. In 1954 the existing tricolour flag was
                                        introduced. The three colours in the flag depict the three services of the
                                        Corps,
                                        red for the Army, deep blue for the Navy and light blue for the Air Force. <br/>
                                        <br/>The
                                        letters NCC and the NCC crest in gold in the middle of the flag encircled by a
                                        wreath of lotus, give the flag a colourful look and a distinct identity.
                                    </p>
                                </div>
                            </div>
                            <div>
                                <h5 class="font-bold text-3xl mt-2 text-[#003b29]">
                                    NCC Pledge
                                </h5>
                                <div class="my-4 text-center bg-emerald-50 py-8 text-gray-700 font-semibold">
                                    <p class="mt-1">"WE THE CADET OF THE NATIONAL CADET CORPS,</p>

                                    <p class="mt-1">DO SOLOEMNLY PLEDGE THAT WE SHALL ALWAYS UPHOLD THE UNITY OF
                                        INDIA.</p>

                                    <p class="mt-1">WE RESOLVE TO BE DISCIPLINED AND RESPONSIBLE CITIZEN OF OUR
                                        NATION.</p>

                                    <p class="mt-1">WE SHALL UNDERTAKE POSITIVE COMMUNITY SERVICE IN THE SPIRIT OF
                                        SELFLESSNESS</p>

                                    <p class="mt-1">AND CONCERN FOR OUR FELLOW BEINGS."</p>
                                </div>
                            </div>
                            <div>
                                <h5 class="font-bold text-3xl my-2 text-[#003b29]">
                                    NCC Song
                                </h5>
                                <div class="my-4 text-center bg-blue-50 py-8 text-gray-700 font-semibold">
                                    <p class="mt-1">Hum Sab Bharatiya Hain, Hum Sab Bharatiya Hain</p>
                                    <p class="mt-1">Apni Manzil Ek Hai,</p>
                                    <p class="mt-1">Ha, Ha, Ha, Ek Hai,</p>
                                    <p class="mt-1">Ho, Ho, Ho, Ek Hai.</p>
                                    <p class="mt-1">Hum Sab Bharatiya Hain.</p>

                                    <p class="mt-1">Kashmir Ki Dharti Rani Hai,</p>
                                    <p class="mt-1">Sartaj Himalaya Hai,</p>
                                    <p class="mt-1">Saadiyon Se Humne Isko Apne Khoon Se Pala Hai</p>
                                    <p class="mt-1">Desh Ki Raksha Ki Khatir Hum Shamshir Utha Lenge,</p>
                                    <p class="mt-1">Hum Shamshir Utha Lenge.</p>

                                    <p class="mt-1">Bikhre Bikhre Taare Hain Hum Lekin Jhilmil Ek Hai,</p>
                                    <p class="mt-1">Ha, Ha, Ha, Ek Hai</p>
                                    <p class="mt-1">Hum Sab Bharatiya Hai.</p>

                                    <p class="mt-1">Mandir Gurudwaare Bhi Hain Yahan</p>
                                    <p class="mt-1">Aur Masjid Bhi Hai Yahan</p>
                                    <p class="mt-1">Girija Ka Hai Ghariyaal Kahin</p>
                                    <p class="mt-1">Mullah ki Kahin Hai Ajaan</p>

                                    <p class="mt-1">Ek Hee Apna Ram Hain, Ek hi Allah Taala Hai,</p>
                                    <p class="mt-1">Ek Hee Allah Taala Hain, Raang Birange Deepak Hain Hum,</p>
                                    <p class="mt-1">Lekin Jagmag Ek Hai, Ha Ha Ha Ek Hai, Ho Ho Ho Ek Hai.</p>

                                    <p class="mt-1">Hum Sab Bharatiya Hain, Hum Sab Bharatiya Hain</p>
                                </div>
                            </div>
                            <div>
                                <h5 class="font-bold text-3xl my-2 text-[#003b29]">
                                    NCC Act
                                </h5>
                                <div class="flex flex-col my-4">
                                    <div class="relative w-full h-[600px] hidden md:block">
                                        <a href="assets/pdf/ncc-act.pdf" class="absolute inset-0 z-10"
                                           target="_blank"></a>
                                        <iframe
                                            src="assets/pdf/ncc-act.pdf"
                                            width="100%"
                                            height="600px"
                                            style="border: none;"
                                            class="z-0 w-full h-full"
                                        ></iframe>
                                    </div>
                                    <a
                                        href="assets/pdf/ncc-act.pdf"
                                        target="_blank"
                                        rel="noopener"
                                        class="text-blue-600 underline block md:hidden"
                                    >
                                        Tap to View the NCC Act PDF
                                    </a>
                                </div>
                            </div>
                            <div>
                                <h5 class="font-bold text-3xl my-2 text-[#003b29]">
                                    NCC Rules
                                </h5>
                                <div class="flex flex-col my-4">
                                    <div class="relative w-full h-[600px] hidden md:block">
                                        <a href="assets/pdf/ncc-rules.pdf" class="absolute inset-0 z-10"
                                           target="_blank"></a>
                                        <iframe
                                            src="assets/pdf/ncc-rules.pdf"
                                            width="100%"
                                            height="600px"
                                            style="border: none;"
                                            class="z-0 w-full h-full"
                                        ></iframe>
                                    </div>
                                    <a
                                        href="assets/pdf/ncc-rules.pdf"
                                        target="_blank"
                                        rel="noopener"
                                        class="text-blue-600 underline block md:hidden"
                                    >
                                        Tap to Open the NCC Rules Document
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="container mx-auto px-4 lg:px-6 xl:px-32" *ngSwitchCase="'ano'">
                            <div>
                                <h5 class="font-bold text-[#003b29] text-3xl mt-2">
                                    List of Associate NCC Officers (ANOs) and Caretakers (CTs)
                                </h5>
                                <table class="table-auto w-full border border-gray-300 my-4">
                                    <thead>
                                    <tr class="bg-gray-100">
                                        <th class="border px-4 py-2">S. No.</th>
                                        <th class="border px-4 py-2">Name</th>
                                        <th class="border px-4 py-2">Unit</th>
                                        <th class="border px-4 py-2">College</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td class="border px-4 py-2">1.</td>
                                        <td class="border px-4 py-2">Mr. Rohit Kumar (CT)</td>
                                        <td class="border px-4 py-2">9 HP NCC BN</td>
                                        <td class="border px-4 py-2">Arni University</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="hidden md:grid grid-cols-3 gap-6 mt-12">
                                <div class="relative">
                                    <a href="assets/pdf/ano-pdfs/application-for-appointment-of-ano.pdf" target="_blank"
                                       class="absolute inset-0 z-10"></a>
                                    <iframe
                                        src="assets/pdf/ano-pdfs/application-for-appointment-of-ano.pdf"
                                        class="w-full h-64 border shadow z-0 pointer-events-none"
                                        style="border: none;"
                                    ></iframe>
                                    <h3 class="text-center text-[#003b29] font-bold text-xl mt-2">Application For
                                        Appointment of ANO</h3>
                                </div>

                                <div class="relative">
                                    <a href="assets/pdf/ano-pdfs/promotions.pdf" target="_blank"
                                       class="absolute inset-0 z-10"></a>
                                    <iframe
                                        src="assets/pdf/ano-pdfs/promotions.pdf"
                                        class="w-full h-64 border shadow z-0 pointer-events-none"
                                        style="border: none;"
                                    ></iframe>
                                    <h3 class="text-center text-[#003b29] font-bold text-xl mt-2">Promotion of ANOs</h3>
                                </div>

                                <div class="relative">
                                    <a href="assets/pdf/ano-pdfs/honorarium.pdf" target="_blank"
                                       class="absolute inset-0 z-10"></a>
                                    <iframe
                                        src="assets/pdf/ano-pdfs/honorarium.pdf"
                                        class="w-full h-64 border shadow z-0 pointer-events-none"
                                        style="border: none;"
                                    ></iframe>
                                    <h3 class="text-center text-[#003b29] font-bold text-xl mt-2">Honorarium to ANOs &
                                        CTs</h3>
                                </div>

                                <div class="relative">
                                    <a href="assets/pdf/ano-pdfs/acr-form-ano.pdf" target="_blank"
                                       class="absolute inset-0 z-10"></a>
                                    <iframe
                                        src="assets/pdf/ano-pdfs/acr-form-ano.pdf"
                                        class="w-full h-64 border shadow z-0 pointer-events-none"
                                        style="border: none;"
                                    ></iframe>
                                    <h3 class="text-center text-[#003b29] font-bold text-xl mt-2">ACR form for ANOs</h3>
                                </div>

                                <div class="relative">
                                    <a href="assets/pdf/ano-pdfs/form-for-honorarium.pdf" target="_blank"
                                       class="absolute inset-0 z-10"></a>
                                    <iframe
                                        src="assets/pdf/ano-pdfs/form-for-honorarium.pdf"
                                        class="w-full h-64 border shadow z-0 pointer-events-none"
                                        style="border: none;"
                                    ></iframe>
                                    <h3 class="text-center text-[#003b29] font-bold text-xl mt-2">Honorarium form for
                                        ANO</h3>
                                </div>

                                <div class="relative">
                                    <a href="assets/pdf/ano-pdfs/ano-hand-book.pdf" target="_blank"
                                       class="absolute inset-0 z-10"></a>
                                    <iframe
                                        src="assets/pdf/ano-pdfs/ano-hand-book.pdf"
                                        class="w-full h-64 border shadow z-0 pointer-events-none"
                                        style="border: none;"
                                    ></iframe>
                                    <h3 class="text-center text-[#003b29] font-bold text-xl mt-2">ANOs Handbook</h3>
                                </div>
                            </div>
                            <div class="md:hidden mt-6 space-y-4 my-8">
                                <div>
                                    <h5 class="font-bold text-xl text-[#003b29]">Application For Appointment of ANO</h5>
                                    <a
                                        href="assets/pdf/ano-pdfs/application-for-appointment-of-ano.pdf"
                                        target="_blank"
                                        rel="noopener"
                                        class="text-blue-600 underline block"
                                    >
                                        Tap to Open
                                    </a>
                                </div>

                                <div>
                                    <h5 class="font-bold text-xl text-[#003b29]">Promotion of ANOs</h5>
                                    <a
                                        href="assets/pdf/ano-pdfs/promotions.pdf"
                                        target="_blank"
                                        rel="noopener"
                                        class="text-blue-600 underline block"
                                    >
                                        Tap to Open
                                    </a>
                                </div>

                                <div>
                                    <h5 class="font-bold text-xl text-[#003b29]">Honorarium to ANOs & CTs</h5>
                                    <a
                                        href="assets/pdf/ano-pdfs/honorarium.pdf"
                                        target="_blank"
                                        rel="noopener"
                                        class="text-blue-600 underline block"
                                    >
                                        Tap to Open
                                    </a>
                                </div>

                                <div>
                                    <h5 class="font-bold text-xl text-[#003b29]">ACR form for ANOs</h5>
                                    <a
                                        href="assets/pdf/ano-pdfs/acr-form-ano.pdf"
                                        target="_blank"
                                        rel="noopener"
                                        class="text-blue-600 underline block"
                                    >
                                        Tap to Open
                                    </a>
                                </div>

                                <div>
                                    <h5 class="font-bold text-xl text-[#003b29]">Honorarium form for ANO</h5>
                                    <a
                                        href="assets/pdf/ano-pdfs/form-for-honorarium.pdf"
                                        target="_blank"
                                        rel="noopener"
                                        class="text-blue-600 underline block"
                                    >
                                        Tap to Open
                                    </a>
                                </div>

                                <div>
                                    <h5 class="font-bold text-xl text-[#003b29]">ANOs Handbook</h5>
                                    <a
                                        href="assets/pdf/ano-pdfs/ano-hand-book.pdf"
                                        target="_blank"
                                        rel="noopener"
                                        class="text-blue-600 underline block"
                                    >
                                        Tap to Open
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="container mx-auto px-4 lg:px-6 xl:px-32" *ngSwitchCase="'cadet'">
                            <div>
                                <h5 class="font-bold text-3xl mt-2 text-[#003b29]">
                                    Cadet's Commandments
                                </h5>
                                <ol class="list-decimal list-inside text-gray-700 space-y-2 my-4 bg-emerald-50 py-8 px-4 font-semibold">
                                    <li>I will ensure construction of toilet in my house and motivate at least 10
                                        persons for the same.
                                    </li>
                                    <li>I will be an 'Aadhar' Indian and would motivate 10 more persons to be one.</li>
                                    <li>I will donate blood at least once every year.</li>
                                    <li>I will make only digital transactions wherever possible and motivate others for
                                        the same.
                                    </li>
                                    <li>I will plant minimum two trees in a year and care for the same.</li>
                                    <li>I will obtain my voter and PAN Card once I have crossed 18 years of age.</li>
                                    <li>I will ensure garbage segregation in my house and within 100 m of my
                                        neighbourhood.
                                    </li>
                                    <li>I will undertake 100 hours of shramdaan for social service.</li>
                                    <li>I will help physically-challenged persons to live their dreams.</li>
                                    <li>I will be a role model for gender sensitivity, secular outlook and spirit of
                                        nationalism without any regional bias.
                                    </li>
                                    <li>I will rush to help any accident victim.</li>
                                    <li>I will always uphold motto of NCC - 'Unity and Discipline'. I will be equally
                                        disciplined when not under observation.
                                    </li>
                                </ol>
                            </div>
                            <div>
                                <h5 class="font-bold text-3xl my-2 text-[#003b29]">
                                    Syllabus
                                </h5>
                                <div class="flex flex-col my-4">
                                    <div class="relative w-full h-[600px] hidden md:block">
                                        <a href="assets/pdf/cadet-syllabus.pdf" class="absolute inset-0 z-10"
                                           target="_blank"></a>
                                        <iframe
                                            src="assets/pdf/cadet-syllabus.pdf"
                                            width="100%"
                                            height="600px"
                                            style="border: none;"
                                            class="z-0 w-full h-full"
                                        ></iframe>
                                    </div>
                                    <a
                                        href="assets/pdf/cadet-syllabus.pdf"
                                        target="_blank"
                                        rel="noopener"
                                        class="text-blue-600 underline block md:hidden"
                                    >
                                        Tap to View the Cadet Syllabus
                                    </a>
                                </div>
                            </div>
                            <div>
                                <h5 class="font-bold text-3xl my-2 text-[#003b29]">
                                    Cadets' Handbook
                                </h5>
                                <table class="table-auto w-full border border-gray-300 my-4">
                                    <thead>
                                    <tr class="bg-gray-100">
                                        <th class="border px-4 py-2">S. No.</th>
                                        <th class="border px-4 py-2">Course</th>
                                        <th class="border px-4 py-2">Subjects</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td class="border px-4 py-2">1.</td>
                                        <td class="border px-4 py-2">Common</td>
                                        <td class="border px-4 py-2">
                                            <a href="http://nccindia.nic.in/en/node/323" target="_blank"
                                               class="text-green-700 underline">
                                                Handbook : Common Subject SD / SW
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">2.</td>
                                        <td class="border px-4 py-2">Army</td>
                                        <td class="border px-4 py-2">
                                            <a href="http://nccindia.nic.in/en/node/325" target="_blank"
                                               class="text-green-700 underline">
                                                Army NCC Cadet Handbook Specialised Subject SD/SW
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">3.</td>
                                        <td class="border px-4 py-2">Navy</td>
                                        <td class="border px-4 py-2">
                                            <a href="http://nccindia.nic.in/en/node/327" target="_blank"
                                               class="text-green-700 underline">
                                                Navy NCC Cadet Handbook SD/SW
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">4.</td>
                                        <td class="border px-4 py-2">Air Force</td>
                                        <td class="border px-4 py-2">
                                            <a href="http://nccindia.nic.in/en/node/329" target="_blank"
                                               class="text-green-700 underline">
                                                Air Force NCC Cadet Handbook SD/SW
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border px-4 py-2">5.</td>
                                        <td class="border px-4 py-2">Miscellaneous</td>
                                        <td class="border px-4 py-2">
                                            <a href="http://nccindia.nic.in/en/node/271" target="_blank"
                                               class="text-green-700 underline">
                                                Personality Development and Leadership
                                            </a>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>

                            </div>
                            <div>
                                <h5 class="font-bold text-3xl my-2 text-[#003b29]">
                                    Cadet Enrollment form SD/SW
                                </h5>
                                <div class="flex flex-col my-4">
                                    <div class="relative w-full h-[600px] hidden md:block">
                                        <a href="assets/pdf/cadet-enrollment-pdf.pdf" class="absolute inset-0 z-10"
                                           target="_blank"></a>
                                        <iframe
                                            src="assets/pdf/cadet-enrollment-pdf.pdf"
                                            width="100%"
                                            height="600px"
                                            style="border: none;"
                                            class="z-0 w-full h-full"
                                        ></iframe>
                                    </div>
                                    <a
                                        href="assets/pdf/cadet-enrollment-pdf.pdf"
                                        target="_blank"
                                        rel="noopener"
                                        class="text-blue-600 underline block md:hidden"
                                    >
                                        Tap to View the Cadet Enrollment form SD/SW
                                    </a>
                                </div>
                            </div>
                            <div>
                                <h5 class="font-bold text-3xl my-2 text-[#003b29]">
                                    Special Entry Scheme Army
                                </h5>
                                <div class="flex flex-col my-4">
                                    <div class="relative w-full h-[600px] hidden md:block">
                                        <a href="assets/pdf/cadet-common-application-form.pdf"
                                           class="absolute inset-0 z-10"
                                           target="_blank"></a>
                                        <iframe
                                            src="assets/pdf/cadet-common-application-form.pdf"
                                            width="100%"
                                            height="600px"
                                            style="border: none;"
                                            class="z-0 w-full h-full"
                                        ></iframe>
                                    </div>
                                    <a
                                        href="assets/pdf/cadet-common-application-form.pdf"
                                        target="_blank"
                                        rel="noopener"
                                        class="text-blue-600 underline block md:hidden"
                                    >
                                        Tap to View the Common Application Form
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="container mx-auto px-4 lg:px-6 xl:px-32" *ngSwitchCase="'annual-activity'">
                            <div class="mb-4">
                                <h5 class="font-bold text-3xl mt-2 text-[#003b29]">
                                    NCC Activities
                                </h5>

                                <div class="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-4 my-4">
                                    <div *ngFor="let img of nccActivities"
                                         class="overflow-hidden rounded-lg shadow cursor-pointer"
                                         (click)="openNccModal(img)">
                                        <img [src]="img"
                                             alt="Activity Image"
                                             class="w-full h-56 object-cover rounded-lg hover:scale-105 transition-transform duration-300" />
                                    </div>
                                </div>


                                <div
                                    *ngIf="modalImage"
                                    class="fixed inset-0 z-50 bg-black bg-opacity-60 flex items-center justify-center p-4 overflow-auto"
                                >
                                    <div
                                        class="relative rounded-lg max-w-3xl w-full max-h-[90vh] overflow-auto mt-20"
                                    >
                                            <button
                                                class="absolute top-2 right-2 text-gray-800 hover:text-red-500 w-10 h-10 flex items-center justify-center rounded-lg bg-white z-50"
                                                (click)="closeNccModal()"
                                                aria-label="Close"
                                            >
                                                <i class="fa fa-times text-2xl"></i>
                                            </button>
                                        <img
                                            [src]="modalImage"
                                            alt="Full Image"
                                            class="w-full h-auto object-contain rounded max-h-[80vh] mx-auto p-4"
                                        />
                                    </div>
                                </div>
                            </div>
                           <!-- <div class="my-4">
                                <h5 class="font-bold text-3xl mt-2 text-[#003b29]">
                                    NCC Activities 2024-25
                                </h5>
                                <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 py-4">
                                    <div
                                        *ngFor="let event of nccEvents"
                                        (click)="openNccTwoModal(event)"
                                        class="cursor-pointer transform transition-transform duration-300 hover:scale-105 relative"
                                    >
                                        <div class="rounded-lg overflow-hidden shadow-lg">
                                            <img
                                                [src]="event.images[0]"
                                                alt="NCC Activity"
                                                class="w-full h-60 object-cover"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div
                                    *ngIf="selectedNccEvent"
                                    class="fixed inset-0 top-16 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4"
                                >
                                    <div
                                        class="bg-white w-full max-w-6xl h-[70vh] md:h-[80vh] p-6 rounded-lg shadow-xl relative overflow-hidden"
                                    >
                                        <button
                                            (click)="closeNccTwoModal()"
                                            class="absolute top-2 right-2 text-gray-600 hover:text-red-500 text-2xl md:text-3xl font-bold"
                                        >
                                            &times;
                                        </button>
                                        <div *ngIf="selectedNccEvent?.instaLink" class="w-full flex justify-center">
                                            <div class="w-full max-w-[340px] md:max-w-[420px] max-h-[70vh] md:max-h-full overflow-y-auto">
                                                <blockquote
                                                    class="instagram-media w-full"
                                                    [attr.data-instgrm-permalink]="selectedNccEvent.instaLink"
                                                    data-instgrm-version="14"
                                                    style="background:#FFF; border:0; margin: 1rem auto; width: 100%;"
                                                ></blockquote>
                                            </div>
                                        </div>
                                        <div *ngIf="!selectedNccEvent?.instaLink && selectedNccEvent?.images?.length > 1" class="relative h-2/3 w-full overflow-hidden rounded-lg">
                                            <img
                                                *ngFor="let img of selectedNccEvent.images; let i = index"
                                                [src]="img"
                                                [alt]="selectedNccEvent.title"
                                                [class.hidden]="i !== selectedNccEvent.activeImageIndex"
                                                class="absolute inset-0 w-full h-full object-cover md:object-contain transition-opacity duration-500"
                                            />
                                            <button (click)="prevImage(selectedNccEvent, $event)" class="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white/70 md:bg-black text-black md:text-white rounded-full p-2 z-10 text-2xl font-bold">
                                                ‹
                                            </button>
                                            <button (click)="nextImage(selectedNccEvent, $event)" class="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white/70 md:bg-black text-black md:text-white rounded-full p-2 z-10 text-2xl font-bold">
                                                ›
                                            </button>
                                        </div>
                                        <div *ngIf="!selectedNccEvent?.instaLink && selectedNccEvent?.images?.length === 1" class="h-2/3 w-full overflow-hidden">
                                            <img
                                                [src]="selectedNccEvent.images[0]"
                                                [alt]="selectedNccEvent.title"
                                                class="w-full h-full object-cover"
                                            />
                                        </div>
                                        <div class="h-1/3 overflow-y-auto thin-scrollbar p-4" *ngIf="!selectedNccEvent?.instaLink">
                                            <h2 class="text-xl font-bold mt-2">{{ selectedNccEvent.title }}</h2>
                                            <p class="mt-1 text-sm text-gray-600">{{ selectedNccEvent.date }}</p>
                                            <p class="mt-4 text-gray-700 text-justify"
                                               [innerHTML]="selectedNccEvent.description"></p>
                                        </div>
                                    </div>
                                </div>
                            </div>-->
                        </div>
                        <div class="container mx-auto px-4 lg:px-6 xl:px-32" *ngSwitchCase="'achievements'">
                            <div class="">
                                <h5 class="font-bold text-3xl my-2 text-[#003b29]">
                                    National Youth Festival 2025
                                </h5>
                                <img src="assets/img/ncc-achievements/national-youth-festival-2025.jpeg"
                                     class="object-cover w-full my-4">
                            </div>
                            <div class="">
                                <h5 class="font-bold text-3xl my-2 text-[#003b29]">
                                    Our Pride, Our Progress
                                </h5>
                                <img src="assets/img/ncc-achievements/achievements.jpeg"
                                     class="object-cover w-full my-4">
                            </div>
                        </div>
                        <div *ngSwitchDefault>Select a tab to view content.</div>
                    </ng-container>
                </div>
                <div class="text-justify" *ngIf="pageTitle === 'Extra Curricular Activities'">
                    <div class="flex items-start justify-center aarni-font">
                        <div class="grid grid-cols-1 lg:grid-cols-2 gap-2 w-full">
                            <div
                                *ngFor="let event of extraCurricularEvents"
                                (click)="openModal(event)"
                                class="cursor-pointer bg-white rounded-lg shadow-lg overflow-hidden relative w-full"
                            >
                                <div class="relative w-full h-52 overflow-hidden">
                                    <img
                                        [src]="event.images[0]"
                                        [alt]="event.title"
                                        class="w-full h-full object-cover"
                                    />
                                </div>

                                <div class="p-2 md:p-4 relative h-[150px] w-full">
                                    <div
                                        *ngIf="event?.date"
                                        class="absolute -top-6 left-4 bg-red-500 text-white text-sm font-semibold px-4 py-2 rounded-full"
                                    >
                                        {{ event.date }}
                                    </div>
                                    <h3 class="text-md md:text-lg font-semibold text-gray-800 mb-12 text-start md:text-justify line-clamp-3 md:line-clamp-none">
                                        {{ event.title }}
                                    </h3>
                                    <div class="absolute bottom-4 right-4">
                                        <div
                                            class="w-8 h-8 flex items-center justify-center rounded-full border-2 border-pink-500 text-pink-500"
                                        >
                                            ➜
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            *ngIf="selectedEvent"
                            class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4"
                        >
                            <div
                                class="bg-white w-full max-w-6xl h-[80vh] md:h-[80vh] p-6 rounded-lg shadow-xl relative overflow-hidden"
                            >
                                <button
                                    (click)="closeModal()"
                                    class="absolute top-2 right-2 text-gray-600 hover:text-red-500 text-2xl md:text-3xl font-bold"
                                >
                                    &times;
                                </button>
                                <div
                                    *ngIf="selectedEvent.images.length > 1"
                                    class="relative h-2/3 w-full overflow-hidden rounded-lg"
                                >
                                    <img
                                        *ngFor="let img of selectedEvent.images; let i = index"
                                        [src]="img"
                                        [alt]="selectedEvent.title"
                                        [class.hidden]="i !== selectedEvent.activeImageIndex"
                                        class="absolute inset-0 w-full h-full object-cover md:object-contain transition-opacity duration-500"
                                    />
                                    <button
                                        (click)="prevImage(selectedEvent, $event)"
                                        class="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white/70 md:bg-black  text-black md:text-white rounded-full p-2 z-10 text-2xl font-bold"
                                    >
                                        ‹
                                    </button>
                                    <button
                                        (click)="nextImage(selectedEvent, $event)"
                                        class="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white/70 md:bg-black text-black md:text-white rounded-full p-2 z-10 text-2xl font-bold"
                                    >
                                        ›
                                    </button>
                                </div>
                                <div
                                    *ngIf="selectedEvent.images.length === 1"
                                    class="h-2/3 w-full overflow-hidden"
                                >
                                    <img
                                        [src]="selectedEvent.images[0]"
                                        [alt]="selectedEvent.title"
                                        class="w-full h-full object-cover"
                                    />
                                </div>
                                <div class="h-1/3 overflow-y-auto thin-scrollbar p-4">
                                    <h2 class="text-xl font-bold mt-2">{{ selectedEvent.title }}</h2>
                                    <p class="mt-1 text-sm text-gray-600">{{ selectedEvent.date }}</p>
                                    <p class="mt-4 text-gray-700 text-justify"
                                       [innerHTML]="selectedEvent.description"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <aside class="w-full lg:w-1/5 space-y-4 lg:max-h-screen lg:overflow-y-auto overflow-x-hidden pr-2"
               *ngIf="pageTitle === 'Library'">
            <ul class="mt-6">
                <div class="font-medium text-primary-dark mb-4">Related Links</div>
                <li class="text-[13px] text-blue-500 flex items-center">
                                  <span
                                      class="w-[30px] h-[15px] mr-2 bg-gold text-white animate-pulse font-bold text-[8px] flex items-center justify-center rounded-full p-[3px]">NEW</span>
                    <a class="underline" href="https://www.ugc.gov.in/" target="_blank">e-Books@UGC
                        Portal</a>
                </li>
                <li class="text-blue-500 flex items-center">
                                  <span
                                      class="w-[30px] h-[15px] mr-2 bg-gold text-white animate-pulse font-bold text-[8px] flex items-center justify-center rounded-full p-[3px]">NEW</span>
                    <a class="underline"
                       href="https://nptel.ac.in/"
                       target="_blank">NPTEL (Home
                        Page)</a>
                </li>
                <li class="text-blue-500 flex items-center">
                                  <span
                                      class="w-[30px] h-[15px] mr-2 bg-gold text-white animate-pulse font-bold text-[8px] flex items-center justify-center rounded-full p-[3px]">NEW</span>
                    <a class="underline"
                       href="https://ndl.iitkgp.ac.in/"
                       target="_blank">NDL</a>
                </li>
                <li class="text-blue-500 flex items-center">
                                  <span
                                      class="w-[30px] h-[15px] mr-2 bg-gold text-white animate-pulse font-bold text-[8px] flex items-center justify-center rounded-full p-[3px]">NEW</span>
                    <a class="underline"
                       href="https://shodhganga.inflibnet.ac.in/"
                       target="_blank">Shodhganga</a>
                </li>
                <li class="text-blue-500 flex items-center">
                                  <span
                                      class="w-[30px] h-[15px] mr-2 bg-gold text-white animate-pulse font-bold text-[8px] flex items-center justify-center rounded-full p-[3px]">NEW</span>
                    <a class="underline"
                       href="https://www.delnet.in/"
                       target="_blank">Delnet</a>
                </li>
            </ul>
        </aside>
    </div>

</section>
